/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import classes from "./cart.module.css";
import CartItem from "./cartItem";
import CartHeader from "./cartHeader";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Button from "../../../component/button";
import totalCalculator from "../../../helper/totalCalculatorNew";
import CartAcc from "./cartAcc";
import Breadcrumb from "../../../component/breadcrumb";
import { withTranslation } from "react-i18next";
import { TableContainer, Tooltip } from "@mui/material";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import currencyFormatter from "../../../helper/currencyFormatter";
import Loader from "../../../component/loader";
import Input from "../../../component/inputpm";
import {
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import EditIcon from "@mui/icons-material/Edit";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CustomerDetailBlock from "../checkout/review/customerDetailsBlock";
import InputLabel from "@mui/material/InputLabel";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {
  DeleteIconNew,
  EditIconNew,
  EnterArrow,
  PlusIcon,
  RefreshIcon,
  ClipboardWithGear,
} from "../../../component/icons/icons";
import OrderActionDialog from "../order/orderActionDialog";
import UriEncode from "../../../component/uriEncode/uriEncode";
import Card from "@mui/material/Card";
import {
  ChevronDown,
  ChevronUp,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import ShowNoteDialog from "../checkout/review/showNoteDialog";
// import { withStyles } from '@mui/styles';
import OfferingProductSpecCharacteristicsExistingDialog from "../../pm/component/specification/offeringProductSpecCharacteristicsExistingDialog";
import OfferingProductSpecCharacteristicsDialog from "../../pm/component/specification/offeringProductSpecCharacteristicsDialog";
import { withNavigation } from "../../../helper/withNavigation";
import {formatDate} from "../../../helper/dateFormatter";
import { formatNumber } from "../../../helper/numberFormatter";

// Cart component parent class
class Cart extends Component {
  state = {
    open: false,
    // bread: [{ title: this.props.t('CART'), url: "/cart" }],
    bread: [],
    disableCheckout: true,
    cartData: [],
    loading: true,
    customerDetails: {},
    showSelectCustomer: false,
    selectedTreeItems: [],
    stage: 0,
    selectedPaymentMethod: null,
    searching: true,
    mode: "/cart",
    discount: 0,
    discountPercentage: 0,
    priceDueNow: 0,
    priceDueAtInstallation: 0,
    cancellationPriceTotal: 0,
    priceNTCtotal: [{}],
    priceRecuringChargeTotal: [{}],
    priceRecurringCharge: [{}],
    notes: "",
    shipmentMethodTypeId: "ST_OVERNIGHT | FEDEX",
    shipmentMethodTypeList: [
      {
        name: "Federal Express - Standard Overnight",
        value: "ST_OVERNIGHT | FEDEX",
      },
    ],
    removeItemWrning: false,
    itemToRemove: {},
    showClearWarning: false,
    quoteHistory: [],
    workFlowEnabled: false,
    formFields: {},
    isEligibleUser: false,
    quoteId: "",
    eligibleRole: "",
    is_order_status: false,
    order_status_details: {},
    expandBom: false,
    error: {},
    showBanDialog: false,
    custCodeValue: "",
    showCustomerBanError: false,
    modules: {},
    noteData: {},
    showNote: false,
    unsavedChanges: false,
    newestNotes: [],
    allNotesOpen: false,
    bpmnProcessInstanceId: null,

    selectedProductSpecificationOffering: {},
    selectedProductSpecification: {},
    showProductSpecification: false,
    selectedCharacteristics: [],
    onSelectCustomerCallback: null,
  };

  componentDidMount() {
    var modules = JSON.parse(localStorage.getItem("modules"));
    this.setState({ modules: modules ? modules : {} });
    for (let i = 0; i < this.props.solutionList.length; i++) {
      if (this.props.solutionList[i].tenantId === this.props.tenantId) {
        this.setState({
          disableCheckout: false,
        });
        break;
      }
    }
    for (let i = 0; i < this.props.accessoryList.length; i++) {
      if (this.props.accessoryList[i].tenantId === this.props.tenantId) {
        this.setState({
          disableCheckout: false,
        });
        break;
      }
    }
    var preSelectedCustomer = JSON.parse(
      localStorage.getItem("preSelectedCustomer"),
    );
    var preSelectedPaymentMethod = JSON.parse(
      localStorage.getItem("preSelectedPaymentMethod"),
    );
    this.setState({
      customerDetails: preSelectedCustomer,
      selectedPaymentMethod: preSelectedPaymentMethod,
    });
    if (this.props.router.location.pathname === "/cart") {
      var bread = [{ title: this.props.t("CART"), url: "/cart" }];
      this.setState({
        bread,
      });
    }
    if (preSelectedCustomer && preSelectedCustomer.partyId) {
      this.setState({
        mode:
          modules && modules.module_quote === "enabled"
            ? this.props.router.location.pathname
            : "/cart",
      });
      if (this.props.router.location.pathname === "/quote") {
        if (preSelectedCustomer.childFirstName) {
          this.getCustomerQuote(preSelectedCustomer.partyId);
        } else {
          this.getCustomerQuote(
            preSelectedCustomer.partyId,
            preSelectedCustomer.ban,
          );
        }
      } else {
        if (preSelectedCustomer.childFirstName) {
          this.getCustomerCart(preSelectedCustomer.partyId);
        } else {
          this.getCustomerCart(
            preSelectedCustomer.partyId,
            preSelectedCustomer.ban,
          );
        }
      }
      //recalculate the discount when items are added back to the quote.
      var jsonData = {};
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        jsonData.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      if (this.props.router.location.pathname === "/quote") {
        BusApiCall(
          "GET",
          `${constants.busV44UrlPublic}/quote?customerId=${preSelectedCustomer.partyId}&type=NewActivation`,
          jsonData,
        ).then((res) => {
          if (res.data && res.data.length > 0) {
            this.setState({ loading: false });
            var tempCartData = res.data[0];

            //recalculate discount
            if (tempCartData.discountPercentage) {
              var data = {};
              data.quoteItem = tempCartData.cartItem;
              for (var i = 0; i < data.quoteItem.length; i++) {
                data.quoteItem[i].action = "EDIT_QUOTE_DISCOUNT";
              }
              data.action = "EDIT_QUOTE_DISCOUNT";
              data.discount = tempCartData.discountPercentage;
              var selectedCustomer = JSON.parse(
                localStorage.getItem("preSelectedCustomer"),
              );
              data.relatedParty = [];
              if (selectedCustomer) {
                data.relatedParty = [
                  {
                    id: selectedCustomer.ban,
                    partyId: selectedCustomer.partyId,
                    firstName: selectedCustomer.firstName,
                    lastName: selectedCustomer.lastName,
                    role:
                      selectedCustomer && selectedCustomer.role
                        ? selectedCustomer.role
                        : "",
                  },
                ];
              }
              BusApiCall(
                "PATCH",
                `${constants.busV44UrlPublic}/quote/${tempCartData.id}`,
                data,
              ).then((res) => {
                if (res.data.code && res.data.code === "500") {
                  this.props.setErrorMessage(res.data.reason, false);
                  this.setState({ loading: false });
                } else {
                  this.setState({ loading: false });
                  // this.getCustomerQuote(this.state.customerDetails.partyId, this.state.customerDetails.ban)
                  if (this.state.customerDetails.childFirstName) {
                    this.getCustomerQuote(this.state.customerDetails.partyId);
                  } else {
                    this.getCustomerQuote(
                      this.state.customerDetails.partyId,
                      this.state.customerDetails.ban,
                    );
                  }
                }
              });
            }
          }
        });
      }
    } else {
      // this.props.router.navigate("/");
      this.setState({
        mode: this.props.quoteEnabled
          ? this.props.router.location.pathname
          : "/cart",
        showSelectCustomer: true,
        loading: false,
      });
    }
  }

  handleExpandBom = () => {
    this.setState({ expandBom: !this.state.expandBom });
  };

  setSelectCustomerCallback = (callback) => {
    this.onSelectCustomerCallback = callback;
  };

  getQuoteData = () => {
    if (this.state.customerDetails.childFirstName) {
      this.getCustomerQuote(this.state.customerDetails.partyId);
    } else {
      this.getCustomerQuote(
        this.state.customerDetails.partyId,
        this.state.customerDetails.ban,
      );
    }
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  getCustomerCart(id, ban) {
    this.setState({ loading: true, searching: true });
    var jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = localStorage.getItem("selectedSalesChannel");
    }
    BusApiCall(
      "GET",
      `${constants.busPublicServiceUrl}/shoppingCart?partyId=${id}${ban ? "&customerId=" + UriEncode(ban) : ""}`,
      jsonData,
    ).then((res) => {
      var tempCartData = res.data[0];
      if (res.data && res.data.length > 0) {
        var finalCartData = [
          {
            cartItem: [],
            cartTotalPrice: tempCartData.cartTotalPrice,
            contactMedium: tempCartData.contactMedium,
            id: tempCartData.id,
            relatedParty: tempCartData.relatedParty,
          },
        ];
        if (
          tempCartData &&
          tempCartData.cartItem &&
          tempCartData.cartItem.length > 0
        ) {
          for (var s = 0; s < tempCartData.cartItem.length; s++) {
            if (
              tempCartData.cartItem[s].productOffering.includedItems &&
              tempCartData.cartItem[s].productOffering.includedItems.length > 0
            ) {
              for (
                var p = 0;
                p <
                tempCartData.cartItem[s].productOffering.includedItems.length;
                p++
              ) {
                tempCartData.cartItem[s].productOffering.includedItems[
                  p
                ].productSpec = this.updateCategory(
                  tempCartData.cartItem[s].productOffering.includedItems[p]
                    .productSpec,
                );
                // if (tempCartData.cartItem[s].productOffering.includedItems[p].productSpec && tempCartData.cartItem[s].productOffering.includedItems[p].productSpec.category && tempCartData.cartItem[s].productOffering.includedItems[p].productSpec.category.id === 'PSC_CUST_FACING') {
                //     const filteredJson = this.filterChildSpecs(tempCartData.cartItem[s].productOffering.includedItems[p].productSpec);
                //     tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = filteredJson;
                // } else {
                //     tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = {};
                // }
                const cleanedData = this.filterChildSpecs(
                  tempCartData.cartItem[s].productOffering.includedItems[p]
                    .productSpec,
                );
                tempCartData.cartItem[s].productOffering.includedItems[
                  p
                ].productSpec = cleanedData;
              }
            }
          }
          if (this.props.priceSummaryView) {
            for (var i = 0; i < tempCartData.cartItem.length; i++) {
              if (
                tempCartData.cartItem[i].productOffering.includedItems &&
                tempCartData.cartItem[i].productOffering.includedItems.length >
                0
              ) {
                for (
                  var j = 0;
                  j <
                  tempCartData.cartItem[i].productOffering.includedItems.length;
                  j++
                ) {
                  if (
                    !tempCartData.cartItem[i].productOffering.includedItems[j]
                      .customerViewable
                  ) {
                    var viewableIndex = tempCartData.cartItem[
                      i
                    ].productOffering.includedItems.findIndex(
                      (x) => x.customerViewable,
                    );
                    if (viewableIndex > -1) {
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          viewableIndex
                        ].alreadyAdded
                      ) {
                      } else {
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].priceType === "RC"
                        ) {
                          var viewableItem =
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex];
                          if (viewableItem.priceTerm) {
                            var key = `${viewableItem.priceTerm.termPeriod}_${viewableItem.priceTerm.termUomId}`;
                            var found = false;
                            var updatedList = viewableItem.recurringCost
                              ? [...viewableItem.recurringCost]
                              : [];
                            for (var k = 0; k < updatedList.length; k++) {
                              if (updatedList[k].key === key) {
                                updatedList[k].price += viewableItem.price;
                                found = true;
                                break;
                              }
                            }

                            if (!found) {
                              var newObj = {
                                key: key,
                                termPeriod: viewableItem.priceTerm.termPeriod,
                                tenureUom: viewableItem.priceTerm.termUomId,
                                price: viewableItem.price,
                              };
                              updatedList.push(newObj);
                            }
                            viewableItem.recurringCost = updatedList;
                            this.setState({
                              priceRecurringCharge: updatedList,
                            });
                          }
                          // if(viewableItem.priceTerm && viewableItem.priceTerm.termUomId === 'TF_day'){
                          //     if (viewableItem.recurringCostPerDay){
                          //         viewableItem.recurringCostPerDay = viewableItem.recurringCostPerDay + viewableItem.price
                          //     } else {
                          //         viewableItem.recurringCostPerDay = viewableItem.price;
                          //     }
                          //  }
                          //  if(viewableItem.priceTerm && viewableItem.priceTerm.termUomId === 'TF_wk'){
                          //     if (viewableItem.recurringCostPerWeek){
                          //         viewableItem.recurringCostPerWeek = viewableItem.recurringCostPerWeek + viewableItem.price
                          //     } else {
                          //         viewableItem.recurringCostPerWeek = viewableItem.price;
                          //     }
                          //  }
                          // if(viewableItem.priceTerm && viewableItem.priceTerm.termUomId === 'TF_mon'){
                          //     if (viewableItem.recurringCostPerMonth){
                          //         viewableItem.recurringCostPerMonth = viewableItem.recurringCostPerMonth + viewableItem.price
                          //     } else {
                          //         viewableItem.recurringCostPerMonth = viewableItem.price;
                          //     }
                          //  }
                          //  if(viewableItem.priceTerm && viewableItem.priceTerm.termUomId === 'TF_yr'){
                          //     if (viewableItem.recurringCostPerYear){
                          //         viewableItem.recurringCostPerYear = viewableItem.recurringCostPerYear + viewableItem.price
                          //     } else {
                          //         viewableItem.recurringCostPerYear = viewableItem.price;
                          //     }
                          //  }
                          // if (tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost) {
                          //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost + tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].price;
                          // } else {
                          //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].price;
                          // }
                        } else {
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].nonRecurringCost
                          ) {
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[
                              viewableIndex
                            ].nonRecurringCost =
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].nonRecurringCost +
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].price;
                          } else {
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[
                              viewableIndex
                            ].nonRecurringCost =
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].price;
                          }
                        }
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].otherPrices &&
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].otherPrices.length > 0
                        ) {
                          for (
                            var k = 0;
                            k <
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].otherPrices.length;
                            k++
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "DEPOSIT"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].depositPrice
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].depositPrice =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].depositPrice +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].depositPrice =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "USAGE_CHARGE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].usageCharge
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].usageCharge =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].usageCharge +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].usageCharge =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "SETUP_FEE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].setupFee
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].setupFee =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].setupFee +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].setupFee =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "CANCELLATION_PRICE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex]
                                  .cancellationPrice
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].cancellationPrice =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex]
                                    .cancellationPrice +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].cancellationPrice =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                          }
                        }
                        tempCartData.cartItem[i].productOffering.includedItems[
                          viewableIndex
                        ].alreadyAdded = true;
                      }
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].priceType === "RC"
                      ) {
                        var viewableItem =
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex];

                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[j].priceTerm
                        ) {
                          var key = `${tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termPeriod}_${tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termUomId}`;
                          var found = false;
                          var updatedList = viewableItem.recurringCost
                            ? [...viewableItem.recurringCost]
                            : [];

                          for (var k = 0; k < updatedList.length; k++) {
                            if (updatedList[k].key === key) {
                              updatedList[k].price +=
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].price;
                              found = true;
                              break;
                            }
                          }

                          if (!found) {
                            var newObj = {
                              key: key,
                              termPeriod:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].priceTerm.termPeriod,
                              tenureUom:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].priceTerm.termUomId,
                              price:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].price,
                            };
                            updatedList.push(newObj);
                          }
                          viewableItem.recurringCost = updatedList;
                          this.setState({ priceRecurringCharge: updatedList });
                        }
                        // if(tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm && tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termUomId === 'TF_day'){
                        //     if (viewableItem.recurringCostPerDay){
                        //         viewableItem.recurringCostPerDay = viewableItem.recurringCostPerDay + tempCartData.cartItem[i].productOffering.includedItems[j].price
                        //     } else {
                        //         viewableItem.recurringCostPerDay = tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        //     }
                        //  }
                        //  if(tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm && tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termUomId === 'TF_wk'){
                        //     if (viewableItem.recurringCostPerWeek){
                        //         viewableItem.recurringCostPerWeek = viewableItem.recurringCostPerWeek + tempCartData.cartItem[i].productOffering.includedItems[j].price
                        //     } else {
                        //         viewableItem.recurringCostPerWeek = tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        //     }
                        //  }
                        // if(tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm && tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termUomId === 'TF_mon'){
                        //     if (viewableItem.recurringCostPerMonth){
                        //         viewableItem.recurringCostPerMonth = viewableItem.recurringCostPerMonth + tempCartData.cartItem[i].productOffering.includedItems[j].price
                        //     } else {
                        //         viewableItem.recurringCostPerMonth = tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        //     }
                        //  }
                        //  if(tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm && tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termUomId === 'TF_yr'){
                        //     if (viewableItem.recurringCostPerYear){
                        //         viewableItem.recurringCostPerYear = viewableItem.recurringCostPerYear + tempCartData.cartItem[i].productOffering.includedItems[j].price
                        //     } else {
                        //         viewableItem.recurringCostPerYear = tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        //     }
                        //  }
                        // if (tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost) {
                        //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost + tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        // } else {
                        //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        // }
                      } else {
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].nonRecurringCost
                        ) {
                          tempCartData.cartItem[
                            i
                          ].productOffering.includedItems[
                            viewableIndex
                          ].nonRecurringCost =
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].nonRecurringCost +
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].price;
                        } else {
                          tempCartData.cartItem[
                            i
                          ].productOffering.includedItems[
                            viewableIndex
                          ].nonRecurringCost =
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[j].price;
                        }
                      }
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].otherPrices &&
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].otherPrices.length > 0
                      ) {
                        for (
                          var k = 0;
                          k <
                          tempCartData.cartItem[i].productOffering
                            .includedItems[j].otherPrices.length;
                          k++
                        ) {
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "DEPOSIT"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].depositPrice
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].depositPrice =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].depositPrice +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].depositPrice =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "USAGE_CHARGE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].usageCharge
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].usageCharge =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].usageCharge +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].usageCharge =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "SETUP_FEE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].setupFee
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].setupFee =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].setupFee +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].setupFee =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "CANCELLATION_PRICE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].cancellationPrice
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].cancellationPrice =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex]
                                  .cancellationPrice +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].cancellationPrice =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          let firstPromise = new Promise((resolve, reject) => resolve());
          var firstElements = tempCartData.cartItem;
          firstElements.forEach((element, index, array) => {
            firstPromise = firstPromise.then(() => {
              return BusApiCall(
                "GET",
                `${constants.busInternalUrl}/promos/packaged-solutions/${element.productOffering.id}`,
              )
                .then((promoRes) => {
                  var promoList = promoRes.data;
                  if (promoList && promoList.length > 0) {
                    var promoIndex = promoList.findIndex(
                      (p) => p.type === "VOLUME_PRICING",
                    );
                    if (promoIndex > -1) {
                      var secondPromise = new Promise((resolve, reject) =>
                        resolve(),
                      );
                      secondPromise = secondPromise.then(() => {
                        return BusApiCall(
                          "GET",
                          `${constants.busInternalUrl}/promos/${promoList[promoIndex].id}`,
                        )
                          .then((promo) => {
                            var promoDetail = promo.data;
                            var promoParty = promoDetail.promoPartyList;
                            var partyAllIndex = promoParty.findIndex(
                              (x) => x.partyId === "all",
                            );
                            var partyIndex = promoParty.findIndex(
                              (x) => x.partyId === this.props.tenantId,
                            );
                            var promoCustomer = promoDetail.promoCustomerList;
                            var customerIndexAll = promoCustomer.findIndex(
                              (x) => x.partyId === "all",
                            );
                            var customerIndex = promoCustomer.findIndex(
                              (x) =>
                                x.partyId ===
                                this.state.customerDetails.partyId,
                            );

                            if (partyAllIndex > -1 || partyIndex > -1) {
                              if (customerIndex > -1 || customerIndexAll > -1) {
                                var rulesList = promoDetail.promoRuleList;
                                for (var j = 0; j < rulesList.length; j++) {
                                  var conditionsList = rulesList[j]
                                    .promoConditionList
                                    ? rulesList[j].promoConditionList
                                    : [];
                                  var amount = 0;
                                  if (
                                    rulesList[j].promoActionList &&
                                    rulesList[j].promoActionList.length > 0
                                  ) {
                                    amount =
                                      rulesList[j].promoActionList[0].amount;
                                    var minimumQty = 0;
                                    var maximumQty = 0;
                                    var offeringQty =
                                      element.productOffering.quantity;
                                    if (conditionsList.length > 0) {
                                      for (
                                        var k = 0;
                                        k < conditionsList.length;
                                        k++
                                      ) {
                                        if (
                                          conditionsList[k].customMethodId ===
                                          "PPC_PRODUCT_QUANT"
                                        ) {
                                          if (
                                            conditionsList[k].operatorEnumId ===
                                            "PPC_GTE"
                                          ) {
                                            minimumQty = Number(
                                              conditionsList[k].condValue,
                                            );
                                          }
                                          if (
                                            conditionsList[k].operatorEnumId ===
                                            "PPC_LTE"
                                          ) {
                                            maximumQty = Number(
                                              conditionsList[k].condValue,
                                            );
                                          }
                                        }
                                        if (conditionsList.length === k + 1) {
                                          if (minimumQty && maximumQty) {
                                            if (
                                              offeringQty >= minimumQty &&
                                              offeringQty <= maximumQty
                                            ) {
                                              var tempElement = element;
                                              tempElement.productOffering.specialPricing =
                                              {
                                                id: promoDetail.promoId,
                                                type: "VOLUME_PRICING",
                                              };
                                              var originalIncludedItems =
                                                element.productOffering
                                                  .includedItems;
                                              var tempIncludedItems = [];
                                              tempElement.discountDetails = {
                                                value: amount,
                                                rcDiscount: 0,
                                                nrDiscount: 0,
                                              };
                                              for (
                                                var l = 0;
                                                l <
                                                originalIncludedItems.length;
                                                l++
                                              ) {
                                                var item = {
                                                  ...originalIncludedItems[l],
                                                };
                                                if (
                                                  originalIncludedItems[l]
                                                    .price > 0
                                                ) {
                                                  var discount =
                                                    (originalIncludedItems[l]
                                                      .price *
                                                      amount) /
                                                    100;
                                                  // item.price = originalIncludedItems[l].price - (originalIncludedItems[l].price * amount) / 100;
                                                  if (
                                                    originalIncludedItems[l]
                                                      .priceType === "NR"
                                                  ) {
                                                    tempElement.discountDetails.nrDiscount =
                                                      tempElement
                                                        .discountDetails
                                                        .nrDiscount +
                                                      discount *
                                                      (offeringQty *
                                                        item.quantity);
                                                    var nrIndex =
                                                      finalCartData[0].cartTotalPrice.findIndex(
                                                        (x) =>
                                                          x.priceType === "NR",
                                                      );
                                                    if (nrIndex > -1) {
                                                      var newNRTotal =
                                                        finalCartData[0]
                                                          .cartTotalPrice[
                                                          nrIndex
                                                        ].price -
                                                        discount *
                                                        (offeringQty *
                                                          item.quantity);
                                                      finalCartData[0].cartTotalPrice[
                                                        nrIndex
                                                      ].price = newNRTotal;
                                                    }
                                                  }
                                                  if (
                                                    originalIncludedItems[l]
                                                      .priceType === "RC"
                                                  ) {
                                                    tempElement.discountDetails.rcDiscount =
                                                      tempElement
                                                        .discountDetails
                                                        .rcDiscount +
                                                      discount *
                                                      (offeringQty *
                                                        item.quantity);
                                                    var rcIndex =
                                                      finalCartData[0].cartTotalPrice.findIndex(
                                                        (x) =>
                                                          x.priceType === "RC",
                                                      );
                                                    if (rcIndex > -1) {
                                                      var newRCTotal =
                                                        finalCartData[0]
                                                          .cartTotalPrice[
                                                          rcIndex
                                                        ].price -
                                                        discount *
                                                        (offeringQty *
                                                          item.quantity);
                                                      finalCartData[0].cartTotalPrice[
                                                        rcIndex
                                                      ].price = newRCTotal;
                                                    }
                                                  }
                                                  tempIncludedItems.push(item);
                                                  if (
                                                    l ===
                                                    originalIncludedItems.length -
                                                    1
                                                  ) {
                                                    tempElement.productOffering.includedItems =
                                                      tempIncludedItems;
                                                    finalCartData[0].cartItem.push(
                                                      tempElement,
                                                    );
                                                    // if (index === (array.length - 1)) {
                                                    this.setNewCart(
                                                      finalCartData,
                                                    );
                                                    // }
                                                  }
                                                } else {
                                                  tempIncludedItems.push(item);
                                                  if (
                                                    l ===
                                                    originalIncludedItems.length -
                                                    1
                                                  ) {
                                                    tempElement.productOffering.includedItems =
                                                      tempIncludedItems;
                                                    finalCartData[0].cartItem.push(
                                                      tempElement,
                                                    );
                                                    // if (index === (array.length - 1)) {
                                                    this.setNewCart(
                                                      finalCartData,
                                                    );
                                                    // }
                                                  }
                                                }
                                              }
                                            } else {
                                              if (rulesList.length === j + 1) {
                                                var elIndex =
                                                  finalCartData[0].cartItem.findIndex(
                                                    (x) => x.id === element.id,
                                                  );
                                                if (elIndex === -1) {
                                                  finalCartData[0].cartItem.push(
                                                    element,
                                                  );
                                                }
                                                this.setNewCart(finalCartData);
                                              }
                                              // if (index === (array.length - 1)) {
                                              // }
                                            }
                                          }
                                          // else if (minimumQty) {
                                          //     if (offeringQty >= minimumQty) {
                                          //         var tempElement = element;
                                          //         var originalIncludedItems = element.productOffering.includedItems;
                                          //         var tempIncludedItems = [];
                                          //         for (var l = 0; l < originalIncludedItems.length; l++) {
                                          //             var item = { ...originalIncludedItems[l] };
                                          //             if (originalIncludedItems[l].price > 0) {
                                          //                 var discount = (originalIncludedItems[l].price * amount) / 100;
                                          //                 item.price = originalIncludedItems[l].price - (originalIncludedItems[l].price * amount) / 100;
                                          //                 item.discount = discount;
                                          //                 tempIncludedItems.push(item);
                                          //                 if (l === (originalIncludedItems.length - 1)) {
                                          //                     tempElement.productOffering.includedItems = tempIncludedItems;
                                          //                     finalCartData[0].cartItem.push(tempElement);
                                          //                     if (originalIncludedItems[l].priceType === 'NR') {
                                          //                         var nrIndex = finalCartData[0].cartTotalPrice.findIndex(x => x.priceType === 'NR');
                                          //                         if (nrIndex > -1) {
                                          //                             var newNRTotal = finalCartData[0].cartTotalPrice[nrIndex].price - (discount * offeringQty);
                                          //                             finalCartData[0].cartTotalPrice[nrIndex].price = newNRTotal;
                                          //                         }
                                          //                     }
                                          //                     if (originalIncludedItems[l].priceType === 'RC') {
                                          //                         var rcIndex = finalCartData[0].cartTotalPrice.findIndex(x => x.priceType === 'RC');
                                          //                         if (nrIndex > -1) {
                                          //                             var newNRTotal = finalCartData[0].cartTotalPrice[rcIndex].price - (discount * offeringQty);
                                          //                             finalCartData[0].cartTotalPrice[rcIndex].price = newNRTotal;
                                          //                         }
                                          //                     }
                                          //                     // if (index === (array.length - 1)) {
                                          //                     this.setNewCart(finalCartData);
                                          //                     // }
                                          //                 }
                                          //             } else {
                                          //                 // if (index === (array.length - 1)) {
                                          //                 this.setNewCart(finalCartData);
                                          //                 // }
                                          //             }
                                          //         }
                                          //     } else {
                                          //         finalCartData[0].cartItem.push(element);
                                          //         // if (index === (array.length - 1)) {
                                          //         this.setNewCart(finalCartData);
                                          //         // }
                                          //     }
                                          // }
                                        }
                                      }
                                    } else {
                                      if (rulesList.length === j + 1) {
                                        var elIndex =
                                          finalCartData[0].cartItem.findIndex(
                                            (x) => x.id === element.id,
                                          );
                                        if (elIndex === -1) {
                                          finalCartData[0].cartItem.push(
                                            element,
                                          );
                                        }
                                        this.setNewCart(finalCartData);
                                      }
                                    }
                                  } else {
                                    if (rulesList.length === j + 1) {
                                      var elIndex =
                                        finalCartData[0].cartItem.findIndex(
                                          (x) => x.id === element.id,
                                        );
                                      if (elIndex === -1) {
                                        finalCartData[0].cartItem.push(element);
                                      }
                                      this.setNewCart(finalCartData);
                                    }
                                  }
                                }
                              } else {
                                finalCartData[0].cartItem.push(element);
                                if (index === array.length - 1) {
                                  this.setNewCart(finalCartData);
                                }
                              }
                            } else {
                              finalCartData[0].cartItem.push(element);
                              if (index === array.length - 1) {
                                this.setNewCart(finalCartData);
                              }
                            }
                          })
                          .catch((err) => {
                            finalCartData[0].cartItem.push(element);
                            if (index === array.length - 1) {
                              this.setNewCart(finalCartData);
                            }
                          });
                      });
                    } else {
                      finalCartData[0].cartItem.push(element);
                      if (index === array.length - 1) {
                        this.setNewCart(finalCartData);
                      }
                    }
                  } else {
                    finalCartData[0].cartItem.push(element);
                    if (index === array.length - 1) {
                      this.setNewCart(finalCartData);
                    }
                  }
                })
                .catch((err) => {
                  finalCartData[0].cartItem.push(element);
                  if (index === array.length - 1) {
                    this.setNewCart(finalCartData);
                  }
                });
            });
          });
        }
        if (this.props.priceSummaryView) {
          this.calculatePrices();
        }
      } else {
        this.props.setCart([]);
        this.setState({
          cartData: [],
          disableCheckout: true,
          searching: false,
          loading: false,
        });
      }
    });
  }

  updateCategory = (spec) => {
    // If the object has a category and it matches, update it
    if (spec.category && spec.category.id === "Customer Facing") {
      spec.category.id = "PSC_CUST_FACING";
    }

    // If it has productSpecificationRelationship, process each child recursively
    if (
      spec.productSpecificationRelationship &&
      spec.productSpecificationRelationship.length
    ) {
      spec.productSpecificationRelationship =
        spec.productSpecificationRelationship.map(this.updateCategory);
    }

    return spec;
  };

  filterChildSpecs = (data) => {
    // if (!spec.productSpecificationRelationship) return spec;

    // // Keep only productSpecificationRelationship with category === "PSC_CUST_FACING"
    // spec.productSpecificationRelationship = spec.productSpecificationRelationship
    //     .filter(child => child.category && child.category.id === 'PSC_CUST_FACING')
    //     .map(child => this.filterChildSpecs(child)); // Recurse!

    // return spec;

    // Base case: if the object has a category and it's not PSC_CUST_FACING
    if (data.category?.id !== "PSC_CUST_FACING") {
      data.productSpecCharacteristic = [];
    }

    // If there are productSpecificationRelationship, apply recursively
    if (Array.isArray(data.productSpecificationRelationship)) {
      data.productSpecificationRelationship.forEach(this.filterChildSpecs);
    }

    return data;
  };

  getCustomerQuote = (id, ban) => {
    this.setState({
      loading: true,
      searching: true,
      isEligibleUser: false,
      eligibleRole: "",
      unsavedChanges: false,
    });
    var jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = localStorage.getItem("selectedSalesChannel");
    }
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/quote?customerId=${id}&type=NewActivation`,
      jsonData,
    )
      .then((res) => {
        if (res.data && res.data.length > 0) {
          var tempCartData = res.data[0];
          var discount = tempCartData.discount;
          var discountPercentage = tempCartData.discountPercentage;
          if (
            tempCartData &&
            tempCartData.cartItem &&
            tempCartData.cartItem.length > 0
          ) {
            for (var i = 0; i < tempCartData.cartItem.length; i++) {
              if (
                tempCartData.cartItem[i].productOffering.includedItems &&
                tempCartData.cartItem[i].productOffering.includedItems.length >
                0
              ) {
                for (
                  var j = 0;
                  j <
                  tempCartData.cartItem[i].productOffering.includedItems.length;
                  j++
                ) {
                  if (
                    !tempCartData.cartItem[i].productOffering.includedItems[j]
                      .customerViewable
                  ) {
                    var viewableIndex = tempCartData.cartItem[
                      i
                    ].productOffering.includedItems.findIndex(
                      (x) => x.customerViewable,
                    );
                    if (viewableIndex > -1) {
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          viewableIndex
                        ].alreadyAdded
                      ) {
                      } else {
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].priceType === "RC"
                        ) {
                          var viewableItem =
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex];
                          if (viewableItem.priceTerm) {
                            var key = `${viewableItem.priceTerm.termPeriod}_${viewableItem.priceTerm.termUomId}`;
                            var found = false;
                            var updatedList = viewableItem.recurringCost
                              ? [...viewableItem.recurringCost]
                              : [];
                            for (var k = 0; k < updatedList.length; k++) {
                              if (updatedList[k].key === key) {
                                updatedList[k].price += viewableItem.price;
                                found = true;
                                break;
                              }
                            }

                            if (!found) {
                              var newObj = {
                                key: key,
                                termPeriod: viewableItem.priceTerm.termPeriod,
                                tenureUom: viewableItem.priceTerm.termUomId,
                                price: viewableItem.price,
                              };
                              updatedList.push(newObj);
                            }
                            this.setState({
                              priceRecurringCharge: updatedList,
                            });
                            viewableItem.recurringCost = updatedList;
                          }
                          // if (tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost) {
                          //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost + tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].price;
                          // } else {
                          //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].price;
                          // }
                        } else {
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].nonRecurringCost
                          ) {
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[
                              viewableIndex
                            ].nonRecurringCost =
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].nonRecurringCost +
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].price;
                          } else {
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[
                              viewableIndex
                            ].nonRecurringCost =
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].price;
                          }
                        }
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].otherPrices &&
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].otherPrices.length > 0
                        ) {
                          for (
                            var k = 0;
                            k <
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].otherPrices.length;
                            k++
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "DEPOSIT"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].depositPrice
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].depositPrice =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].depositPrice +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].depositPrice =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "USAGE_CHARGE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].usageCharge
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].usageCharge =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].usageCharge +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].usageCharge =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "SETUP_FEE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].setupFee
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].setupFee =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].setupFee +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].setupFee =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "CANCELLATION_PRICE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex]
                                  .cancellationPrice
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].cancellationPrice =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex]
                                    .cancellationPrice +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].cancellationPrice =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                          }
                        }
                        tempCartData.cartItem[i].productOffering.includedItems[
                          viewableIndex
                        ].alreadyAdded = true;
                      }
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].priceType === "RC"
                      ) {
                        var viewableItem =
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex];
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[j].priceTerm
                        ) {
                          var key = `${tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termPeriod}_${tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termUomId}`;
                          var found = false;
                          var updatedList = viewableItem.recurringCost
                            ? [...viewableItem.recurringCost]
                            : [];

                          for (var k = 0; k < updatedList.length; k++) {
                            if (updatedList[k].key === key) {
                              updatedList[k].price +=
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].price;
                              found = true;
                              break;
                            }
                          }

                          if (!found) {
                            var newObj = {
                              key: key,
                              termPeriod:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].priceTerm.termPeriod,
                              tenureUom:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].priceTerm.termUomId,
                              price:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].price,
                            };
                            updatedList.push(newObj);
                          }

                          this.setState({ priceRecurringCharge: updatedList });
                          viewableItem.recurringCost = updatedList;
                        }
                        // if (tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost) {
                        //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost + tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        // } else {
                        //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        // }
                      } else {
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].nonRecurringCost
                        ) {
                          tempCartData.cartItem[
                            i
                          ].productOffering.includedItems[
                            viewableIndex
                          ].nonRecurringCost =
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].nonRecurringCost +
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].price;
                        } else {
                          tempCartData.cartItem[
                            i
                          ].productOffering.includedItems[
                            viewableIndex
                          ].nonRecurringCost =
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[j].price;
                        }
                      }
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].otherPrices &&
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].otherPrices.length > 0
                      ) {
                        for (
                          var k = 0;
                          k <
                          tempCartData.cartItem[i].productOffering
                            .includedItems[j].otherPrices.length;
                          k++
                        ) {
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "DEPOSIT"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].depositPrice
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].depositPrice =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].depositPrice +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].depositPrice =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "USAGE_CHARGE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].usageCharge
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].usageCharge =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].usageCharge +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].usageCharge =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "SETUP_FEE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].setupFee
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].setupFee =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].setupFee +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].setupFee =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "CANCELLATION_PRICE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].cancellationPrice
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].cancellationPrice =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex]
                                  .cancellationPrice +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].cancellationPrice =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            var bread = [
              {
                title: this.props.t("QUOTE") + " #" + tempCartData.id,
                url: "/quote",
              },
            ];
            this.setState(
              {
                bread: bread,
                loading: false,
                discount: discount,
                discountPercentage: discountPercentage,
                cartData: [tempCartData],
                quoteHistory:
                  tempCartData.history && tempCartData.history.length > 0
                    ? tempCartData.history
                    : [],
                workFlowEnabled: tempCartData.workFlowEnabled
                  ? tempCartData.workFlowEnabled
                  : false,
                quoteId: tempCartData.id,
                bpmnProcessInstanceId: tempCartData.bpmnProcessInstanceId
                  ? tempCartData.bpmnProcessInstanceId
                  : "",
              },
              () => {
                if (
                  this.state.cartData &&
                  this.state.cartData.length > 0 &&
                  this.state.cartData[0].comments
                ) {
                  const notesCopy = [...this.state.cartData[0].comments];
                  this.setState({
                    newestNotes: notesCopy.splice(0, 3),
                  });
                }
                if (this.state.workFlowEnabled) {
                  this.getBPMNActions();
                }
                if (this.props.priceSummaryView) {
                  this.calculatePrices();
                }
              },
            );
            this.props.setQuote(res.data);
            if (res.data && res.data.length > 0) {
              this.setState({
                disableCheckout: false,
              });
            }
          } else {
            var bread = [{ title: this.props.t("QUOTE"), url: "/quote" }];
            this.props.setQuote([]);
            this.setState({
              bread: bread,
              cartData: [],
              disableCheckout: true,
              searching: false,
              loading: false,
            });
          }
        } else {
          var bread = [{ title: this.props.t("QUOTE"), url: "/quote" }];
          this.props.setQuote([]);
          this.setState({
            bread: bread,
            cartData: [],
            disableCheckout: true,
            searching: false,
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.props.setQuote([]);
        this.setState({
          cartData: [],
          disableCheckout: true,
          searching: false,
          loading: false,
        });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  // getCustomerCart = (id) => {
  //     this.setState({ loading: true, searching: true });
  //     var jsonData = {};
  //     if (this.props.providerType === 'SOLUTION_PROVIDER') {
  //         jsonData.tenantId = localStorage.getItem('selectedSalesChannel');
  //     }
  //     BusApiCall('GET', `${constants.busPublicServiceUrl}/shoppingCart?customerId=${id}`, jsonData).then(res => {
  //         this.setState({
  //             loading: false,
  //             cartData: res.data
  //         }, () => {
  //             this.setState({
  //                 searching: false
  //             })
  //         });
  //         this.props.setCart(res.data);
  //         this.createCustomerCart();
  //         if (res.data && res.data.length > 0) {
  //             this.setState({
  //                 disableCheckout: false
  //             })
  //         }
  //     }).catch(err => {
  //         if (err.response && err.response.data && err.response.data.message) {
  //             this.props.setErrorMessage(err.response.data.message, false)
  //         } else {
  //             this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
  //         }
  //         this.setState({ loading: false, searching: false });
  //     })
  // }

  getBPMNActions = () => {
    var jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = localStorage.getItem("selectedSalesChannel");
    }
    // Get order actions from flowable
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/quotes/${this.state.quoteId}/flowable/bpmn/taskForms`,
      jsonData,
    )
      .then((res) => {
        var is_order_status =
          res.data.is_order_status &&
            (res.data.is_order_status === true ||
              res.data.is_order_status === "true")
            ? true
            : false;
        if (is_order_status) {
          this.setState({
            order_status_details: res.data.order_status_details,
          });
        }
        var formFields = res.data;
        if (formFields.fields && formFields.fields.length > 0) {
          for (var i = 0; i < formFields.fields.length; i++) {
            if (formFields.fields[i].value) {
              formFields.fields[i].value = null;
            }
          }
        }
        this.setState(
          {
            formFields: formFields,
            is_order_status: is_order_status,
          },
          () => {
            this.checkisEligibleUser();
          },
        );
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  checkisEligibleUser = () => {
    var securityGroupsList = this.props.securityGroupsList;
    var groupList = this.state.formFields.identityLinks;
    if (securityGroupsList.includes("ADMIN")) {
      this.setState({
        isEligibleUser: true,
      });
      if (groupList && groupList.length > 0) {
        console.log("check list", groupList);
        if (groupList.length === 1) {
          if (groupList[0].group) {
            this.snakeToSentenceCase(groupList[0].group);
          }
        } else {
          for (var i = 0; i < groupList.length; i++) {
            if (groupList[i].group !== "ADMIN") {
              if (groupList[i].group) {
                this.snakeToSentenceCase(groupList[i].group);
              }
              return;
            }
          }
        }
      }
    } else {
      if (groupList && groupList.length > 0) {
        if (groupList.length === 1) {
          if (groupList[0].group) {
            this.snakeToSentenceCase(groupList[0].group);
          }
          var index = securityGroupsList.findIndex(
            (x) => x === groupList[0].group,
          );
          if (index > -1) {
            this.setState({
              isEligibleUser: true,
            });
            return;
          } else {
            this.setState({
              isEligibleUser: false,
            });
            return;
          }
        } else {
          for (var i = 0; i < groupList.length; i++) {
            if (groupList[i].group !== "ADMIN") {
              if (groupList[i].group) {
                this.snakeToSentenceCase(groupList[i].group);
              }
              return;
            }
          }
          for (var i = 0; i < groupList.length; i++) {
            var index = securityGroupsList.findIndex(
              (x) => x === groupList[i].group,
            );
            if (index > -1) {
              this.setState({
                isEligibleUser: true,
              });
              return;
            } else {
              if (index + 1 === groupList.length) {
                this.setState({
                  isEligibleUser: false,
                });
                return;
              }
            }
          }
        }
      } else {
        this.setState({
          isEligibleUser: false,
          eligibleRole: "",
        });
      }
    }
  };

  snakeToSentenceCase = (val) => {
    var a = val;
    var b = val.split("_");
    var d = "";
    if (b.length > 1) {
      var c = b.map((x) => x.toLowerCase());
      d = c.join(" ");
      var e = d.replace(
        /\w\S*/g,
        (text) =>
          text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
      );
      this.setState({
        eligibleRole: e,
      });
    } else {
      d = val.toLowerCase();
      var e = d.replace(
        /\w\S*/g,
        (text) =>
          text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
      );
      this.setState({
        eligibleRole: e,
      });
    }
  };

  setNewCart = (data) => {
    this.setState(
      {
        loading: false,
        cartData: data,
      },
      () => {
        this.setState({
          searching: false,
        });
        if (this.props.priceSummaryView) {
          this.calculatePrices();
        }
      },
    );
    this.props.setCart(data);
    this.createCustomerCart();
    if (data && data.length > 0) {
      this.setState({
        disableCheckout: false,
      });
    }
  };

  // Close alert modal
  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  // Remove packaged solution
  removeComponent = (index) => {
    if (this.props.solutionList[index].promoId) {
      if (this.props.solutionList.length > 1) {
        for (let i = 0; i < this.props.solutionList.length; i++) {
          if (i !== index) {
            if (this.props.solutionList[i].promoId) {
              this.props.remove(index, "SOL");
              break;
            } else {
              this.props.setPromoBan("");
              this.props.remove(index, "SOL");
            }
          }
        }
      } else {
        this.props.setPromoBan("");
        this.props.remove(index, "SOL");
      }
    } else {
      this.props.remove(index, "SOL");
    }
  };

  // Remove sub item (Accessories, Addons, Setup) of packaged solution
  removeSubComponent = (index, itemType, compType, compIndex) => {
    this.props.removeComponent(index, itemType, compType, compIndex);
  };

  // Change quantity of packaged solution
  changeQuantity = (value, index, type) => {
    this.props.setErrorMessage("", false);
    if (value < 1000) {
      this.props.changeQuantity(value, index, type);
    } else {
      this.props.setErrorMessage(this.props.t("MAX_ITEMS_ERROR"), false);
    }
  };

  // Change quantity of sub item (Accessories, Addons, Setup) of packaged solution
  changeComponentQuantity = (value, index, type, compType, compIndex) => {
    this.props.setErrorMessage("", false);
    if (value < 1000) {
      this.props.changeComponentQuantity(
        value,
        index,
        type,
        compType,
        compIndex,
      );
    } else {
      this.props.setErrorMessage(this.props.t("MAX_ITEMS_ERROR"), false);
    }
  };

  callCheckoutLogin() {
    window.localStorage.setItem("doLogin", true);
    window.location.reload();
  }

  tempChangePSQuantity = (e, item) => {
    if (e.target.name === "quantity") {
      if (+e.target.value > 0 || e.target.value === "") {
        var oldData = [...this.state.cartData];
        var cartItem = oldData[0].cartItem;
        var index = cartItem.findIndex((x) => x.id === item.id);

        if (index > -1) {
          oldData[0].cartItem[index].productOffering.quantity = e.target.value;
          this.setState(
            {
              cartData: oldData,
              unsavedChanges: true,
            },
            () => {
              if (this.props.priceSummaryView) {
                this.calculatePrices();
              }
            },
          );
        }
      } else {
        var oldData = [...this.state.cartData];
        var cartItem = oldData[0].cartItem;
        var index = cartItem.findIndex((x) => x.id === item.id);

        if (index > -1) {
          oldData[0].cartItem[index].productOffering.quantity = 1;
          this.setState(
            {
              cartData: oldData,
              unsavedChanges: true,
            },
            () => {
              if (this.props.priceSummaryView) {
                this.calculatePrices();
              }
            },
          );
        }
      }
    }
  };

  tempChangePSQuantityVerify = (e, item) => {
    if (
      item.productOffering.quantity === "" ||
      item.productOffering.quantity === "0"
    ) {
      var oldData = [...this.state.cartData];
      var cartItem = oldData[0].cartItem;
      var index = cartItem.findIndex((x) => x.id === item.id);

      if (index > -1) {
        oldData[0].cartItem[index].productOffering.quantity = 1;
        this.setState(
          {
            cartData: oldData,
          },
          () => {
            // this.changePSQuantity(e, item, 'onBlur');
            if (this.props.priceSummaryView) {
              this.calculatePrices();
            }
          },
        );
      }
    } else {
      // this.changePSQuantity(e, item, 'onBlur');
    }
  };

  changePSQuantity = (e, item, blur) => {
    if (e.key === "Enter" && +item.productOffering.quantity > 0) {
      if (this.state.mode === "/quote") {
        this.updateQuoteData();
        // this.setState({ loading: true });
        // var payload = {
        //     quoteItem: [
        //         { ...item }
        //     ],
        //     relatedParty: [
        //         {
        //             id: '',
        //             firstName: '',
        //             lastName: '',
        //             role: ''
        //         }
        //     ]
        // }
        // payload.quoteItem[0].productOffering.quantity = +item.productOffering.quantity;
        // payload.quoteItem[0].action = 'MODIFY';
        // var selectedCustomer = JSON.parse(localStorage.getItem('preSelectedCustomer'));
        // if (selectedCustomer.childFirstName) {
        //     payload.relatedParty = [
        //         {
        //             id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.ban : '',
        //             partyId: selectedCustomer.partyId,
        //             firstName: selectedCustomer.childFirstName,
        //             lastName: selectedCustomer.childLastName,
        //             role: (selectedCustomer && selectedCustomer.role) ? selectedCustomer.role : '',
        //         }
        //     ]
        // } else {
        //     payload.relatedParty = [
        //         {
        //             id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.ban : '',
        //             partyId: selectedCustomer.partyId,
        //             firstName: selectedCustomer.firstName,
        //             lastName: selectedCustomer.lastName,
        //             role: (selectedCustomer && selectedCustomer.role) ? selectedCustomer.role : '',
        //         }
        //     ]
        // }
        // if (this.props.providerType === 'SOLUTION_PROVIDER') {
        //     payload.tenantId = localStorage.getItem('selectedSalesChannel');
        // }
        // payload.action = 'EDIT_QUOTE';
        // payload.discount = this.state.discountPercentage;
        // BusApiCall('PATCH', `${constants.busV44UrlPublic}/quote/${this.state.cartData[0].id}`, payload).then(res => {
        //     this.setState({ loading: false });
        //     if (selectedCustomer.childFirstName) {
        //         this.getCustomerQuote(this.state.customerDetails.partyId)
        //     } else {
        //         this.getCustomerQuote(this.state.customerDetails.partyId, this.state.customerDetails.ban)
        //     }
        // }).catch(err => {
        //     if (err.response && err.response.data && err.response.data.message) {
        //         this.props.setErrorMessage(err.response.data.message, false)
        //     } else {
        //         this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
        //     }
        //     this.setState({
        //         loading: false,
        //     })
        // })
      } else {
        this.setState({ loading: true });
        var payload = {
          cartItem: [{ ...item }],
        };
        payload.cartItem[0].productOffering.quantity =
          +item.productOffering.quantity;
        payload.cartItem[0].action = "MODIFY";
        if (this.props.providerType === "SOLUTION_PROVIDER") {
          payload.tenantId = localStorage.getItem("selectedSalesChannel");
        }
        BusApiCall(
          "PATCH",
          `${constants.busPublicServiceUrl}/shoppingCart/${this.state.cartData[0].id}`,
          payload,
        )
          .then((res) => {
            this.setState({ loading: false });
            // this.props.setCart([res.data]);
            // this.getCustomerCart(this.state.customerDetails.partyId)
            if (this.state.customerDetails.childFirstName) {
              this.getCustomerCart(this.state.customerDetails.partyId);
            } else {
              this.getCustomerCart(
                this.state.customerDetails.partyId,
                this.state.customerDetails.ban,
              );
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
    if (this.props.priceSummaryView) {
      this.calculatePrices();
    }
  };

  updateQuoteData = () => {
    if (this.state.mode === "/quote") {
      this.setState({ loading: true });
      console.log("check cart data", this.state.cartData);
      var payload = {
        quoteItem: [...this.state.cartData[0].cartItem],
        relatedParty: [
          {
            id: "",
            firstName: "",
            lastName: "",
            role: "",
          },
        ],
      };
      for (var i = 0; i < payload.quoteItem.length; i++) {
        payload.quoteItem[i].productOffering.quantity =
          +payload.quoteItem[i].productOffering.quantity;
        payload.quoteItem[i].action = "MODIFY";
      }
      // payload.quoteItem[0].productOffering.quantity = +item.productOffering.quantity;
      // payload.quoteItem[0].action = 'MODIFY';
      var selectedCustomer = JSON.parse(
        localStorage.getItem("preSelectedCustomer"),
      );
      if (selectedCustomer.childFirstName) {
        payload.relatedParty = [
          {
            id:
              selectedCustomer && selectedCustomer.ban
                ? selectedCustomer.ban
                : "",
            partyId: selectedCustomer.partyId,
            firstName: selectedCustomer.childFirstName,
            lastName: selectedCustomer.childLastName,
            role:
              selectedCustomer && selectedCustomer.role
                ? selectedCustomer.role
                : "",
          },
        ];
      } else {
        payload.relatedParty = [
          {
            id:
              selectedCustomer && selectedCustomer.ban
                ? selectedCustomer.ban
                : "",
            partyId: selectedCustomer.partyId,
            firstName: selectedCustomer.firstName,
            lastName: selectedCustomer.lastName,
            role:
              selectedCustomer && selectedCustomer.role
                ? selectedCustomer.role
                : "",
          },
        ];
      }
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        payload.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      payload.action = "EDIT_QUOTE";
      payload.discount = this.state.discountPercentage;
      BusApiCall(
        "PATCH",
        `${constants.busV44UrlPublic}/quote/${this.state.cartData[0].id}`,
        payload,
      )
        .then((res) => {
          this.setState({ loading: false });
          if (selectedCustomer.childFirstName) {
            this.getCustomerQuote(this.state.customerDetails.partyId);
          } else {
            this.getCustomerQuote(
              this.state.customerDetails.partyId,
              this.state.customerDetails.ban,
            );
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    } else {
      this.setState({ loading: true });
      var payload = {
        cartItem: [...this.state.cartData[0].cartItem],
      };
      for (var i = 0; i < payload.cartItem.length; i++) {
        payload.cartItem[i].productOffering.quantity =
          +payload.cartItem[i].productOffering.quantity;
        payload.cartItem[i].action = "MODIFY";
      }
      // payload.cartItem[0].productOffering.quantity = +item.productOffering.quantity;
      payload.cartItem[0].action = "MODIFY";
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        payload.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      BusApiCall(
        "PATCH",
        `${constants.busPublicServiceUrl}/shoppingCart/${this.state.cartData[0].id}`,
        payload,
      )
        .then((res) => {
          this.setState({ loading: false });
          // this.props.setCart([res.data]);
          // this.getCustomerCart(this.state.customerDetails.partyId)
          if (this.state.customerDetails.childFirstName) {
            this.getCustomerCart(this.state.customerDetails.partyId);
          } else {
            this.getCustomerCart(
              this.state.customerDetails.partyId,
              this.state.customerDetails.ban,
            );
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    }
  };

  changePSDiscountValue = (e) => {
    if (+e.target.value > -1) {
      this.setState(
        {
          discountPercentage: e.target.value,
        },
        () => { },
      );
    }
  };

  changePSDiscount = (e) => {
    if (
      +this.state.discountPercentage >= 0 &&
      +this.state.discountPercentage < 101
    ) {
      this.setState({ loading: true });
      if (
        +this.state.discountPercentage >= 0 ||
        this.state.discountPercentage === ""
      ) {
        var data = {};
        let quoteItem = [];
        data.quoteItem = this.state.cartData[0].cartItem;

        for (var i = 0; i < data.quoteItem.length; i++) {
          data.quoteItem[i].action = "MODIFY";
          data.quoteItem[i].productOffering.quantity =
            +data.quoteItem[i].productOffering.quantity;
        }
        data.action = "MODIFY";
        data.discount = this.state.discountPercentage;
        var selectedCustomer = JSON.parse(
          localStorage.getItem("preSelectedCustomer"),
        );
        if (selectedCustomer.childFirstName) {
          data.relatedParty = [
            {
              id:
                selectedCustomer && selectedCustomer.ban
                  ? selectedCustomer.ban
                  : "",
              partyId: selectedCustomer.partyId,
              firstName: selectedCustomer.childFirstName,
              lastName: selectedCustomer.childLastName,
              role:
                selectedCustomer && selectedCustomer.role
                  ? selectedCustomer.role
                  : "",
            },
          ];
        } else {
          data.relatedParty = [
            {
              id:
                selectedCustomer && selectedCustomer.ban
                  ? selectedCustomer.ban
                  : "",
              partyId: selectedCustomer.partyId,
              firstName: selectedCustomer.firstName,
              lastName: selectedCustomer.lastName,
              role:
                selectedCustomer && selectedCustomer.role
                  ? selectedCustomer.role
                  : "",
            },
          ];
        }
        BusApiCall(
          "PATCH",
          `${constants.busV44UrlPublic}/quote/${this.state.cartData[0].id}`,
          data,
        )
          .then((res) => {
            this.setState({ loading: true });
            if (res.data.code && res.data.code === "500") {
              this.props.setErrorMessage(res.data.reason, false);
              this.setState({ loading: false });
            } else {
              if (this.state.isSubscriptionMode) {
                this.props.router.navigate(
                  "/quote/" + this.props.router.location.state.subsciptionData.id,
                );
              } else {
                this.props.setQuote(res.data);
                this.setState({ loading: false });
                this.getCustomerQuote(
                  this.state.customerDetails.partyId,
                  this.state.customerDetails.ban,
                );
              }
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
    if (+this.state.discountPercentage < 0) {
      this.props.setErrorMessage(
        this.props.t("NEGATIVE_VALUE_RESTRICTION"),
        false,
      );
      this.setState({ loading: false });
    }
    if (+this.state.discountPercentage > 100) {
      this.props.setErrorMessage(
        this.props.t("DISCOUNT_VALUE_RESTRICTION"),
        false,
      );
      this.setState({ loading: false });
    }
  };

  showRemoveItemWarning = (item) => {
    this.setState({
      itemToRemove: item,
      removeItemWrning: true,
    });
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  removePSFromCart = (val) => {
    if (val) {
      this.setState({ loading: true });
      var payload = {};
      var url = "";
      if (this.state.mode === "/quote") {
        url = `${constants.busV44UrlPublic}/quote/${this.state.cartData[0].id}`;
        payload = {
          quoteItem: [{ ...this.state.itemToRemove }],
        };
        payload.quoteItem[0].action = "DELETE";
        payload.action = "EDIT_QUOTE";
      } else {
        url = `${constants.busPublicServiceUrl}/shoppingCart/${this.state.cartData[0].id}`;
        payload = {
          cartItem: [{ ...this.state.itemToRemove }],
        };
        payload.cartItem[0].action = "DELETE";
      }
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        payload.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      BusApiCall("PATCH", url, payload)
        .then((res) => {
          if (res.data) {
            if (this.state.mode === "/quote") {
              this.setState({
                loading: false,
                removeItemWrning: false,
                itemToRemove: {},
              });
              if (this.state.customerDetails.childFirstName) {
                this.getCustomerQuote(this.state.customerDetails.partyId);
              } else {
                this.getCustomerQuote(
                  this.state.customerDetails.partyId,
                  this.state.customerDetails.ban,
                );
              }
            } else {
              if (this.state.customerDetails.childFirstName) {
                this.getCustomerCart(this.state.customerDetails.partyId);
              } else {
                this.getCustomerCart(
                  this.state.customerDetails.partyId,
                  this.state.customerDetails.ban,
                );
              }
              this.setState({
                loading: false,
                cartData: [res.data],
                removeItemWrning: false,
                itemToRemove: {},
              });
            }
          }
          // if (res.data.cartItem) {
          //     this.setState({ loading: false, cartData: [res.data] });
          //     // this.props.setCart([res.data]);
          //     this.getCustomerCart(this.state.customerDetails.partyId)
          // } else {
          //     this.setState({ loading: false, cartData: [] });
          //     // this.props.setCart([]);
          //     this.getCustomerCart(this.state.customerDetails.partyId)
          // }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            removeItemWrning: false,
            itemToRemove: {},
          });
        });
      if (this.props.priceSummaryView) {
        this.calculatePrices();
      }
    } else {
      this.setState({
        loading: false,
        removeItemWrning: false,
        itemToRemove: {},
      });
    }
  };

  showClearCartWarning = () => {
    this.setState({
      showClearWarning: true,
    });
  };

  clearCustomerCart = (val) => {
    if (val) {
      if (this.state.cartData && this.state.cartData.length > 0) {
        this.setState({ loading: true, disableCheckout: true });
        var jsonData = {};
        if (this.props.providerType === "SOLUTION_PROVIDER") {
          jsonData.tenantId = localStorage.getItem("selectedSalesChannel");
        }
        var url = "";
        if (this.state.mode === "/quote") {
          url = `${constants.busV44UrlPublic}/quote/${this.state.cartData[0].id}`;
        } else {
          url = `${constants.busPublicServiceUrl}/shoppingCart/${this.state.cartData[0].id}`;
        }
        BusApiCall("DELETE", url, jsonData)
          .then((res) => {
            this.setState({
              loading: false,
              cartData: [],
              disableCheckout: true,
              showClearWarning: false,
            });
            if (this.state.mode === "/quote") {
              this.props.setQuote([]);
              this.props.setErrorMessage(this.props.t("QUOTE_CLEARED"), true);
              if (this.state.customerDetails.childFirstName) {
                this.getCustomerQuote(this.state.customerDetails.partyId);
              } else {
                this.getCustomerQuote(
                  this.state.customerDetails.partyId,
                  this.state.customerDetails.ban,
                );
              }
            } else {
              this.props.setCart([]);
              if (this.state.customerDetails.childFirstName) {
                this.getCustomerCart(this.state.customerDetails.partyId);
              } else {
                this.getCustomerCart(
                  this.state.customerDetails.partyId,
                  this.state.customerDetails.ban,
                );
              }
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
              showClearWarning: false,
              disableCheckout: false,
            });
          });
      } else {
        this.setState({
          showClearWarning: false,
        });
      }
    } else {
      this.setState({
        showClearWarning: false,
      });
    }
  };

  selectCustomerClose = (
    currStage,
    data,
    selectedTreeItems,
    selectedPaymentMethod,
  ) => {
    if (data) {
      localStorage.setItem("preSelectedCustomer", JSON.stringify(data));
      localStorage.setItem(
        "preSelectedPaymentMethod",
        JSON.stringify(selectedPaymentMethod),
      );
      var jsonData = {};
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        jsonData.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      if (this.state.mode === "/quote") {
        if (data.childFirstName) {
          this.getCustomerQuote(data.partyId);
        } else {
          this.getCustomerQuote(data.partyId, data.ban);
        }
        BusApiCall(
          "GET",
          `${constants.busPublicServiceUrl}/shoppingCart?partyId=${data.partyId}${data.childFirstName ? "" : "&customerId=" + UriEncode(data.ban)}`,
          jsonData,
        )
          .then((res) => {
            this.props.setCart(res.data);
            // this.setState({ loading: false });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            // this.setState({ loading: false });
          });
      } else {
        if (data.childFirstName) {
          this.getCustomerCart(data.partyId);
        } else {
          this.getCustomerCart(data.partyId, data.ban);
        }
        BusApiCall(
          "GET",
          `${constants.busV44UrlPublic}/quote?customerId=${data.partyId}&type=NewActivation`,
          jsonData,
        )
          .then((res) => {
            this.props.setQuote(res.data);
            // this.setState({ loading: false });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            // this.setState({ loading: false });
          });
      }
      this.setState({
        customerDetails: data,
        selectedTreeItems: selectedTreeItems,
        selectedPaymentMethod: selectedPaymentMethod,
        showSelectCustomer: false,
      });
    } else {
      if (this.state.customerDetails && this.state.customerDetails.partyId) {
      } else {
        this.props.router.navigate("/newOrder");
      }
    }
  };

  createCustomerCart = () => {
    var publicCart = JSON.parse(sessionStorage.getItem("publicCart"));
    if (publicCart) {
      var selectedCustomer = JSON.parse(
        localStorage.getItem("preSelectedCustomer"),
      );
      var newCartData = publicCart;
      newCartData.relatedParty = [];
      if (selectedCustomer.childFirstName) {
        newCartData.relatedParty = [
          {
            // id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.partyId : '',
            partyId: selectedCustomer.partyId,
            firstName: selectedCustomer.childFirstName,
            lastName: selectedCustomer.childLastName,
            role:
              selectedCustomer && selectedCustomer.role
                ? selectedCustomer.role
                : "",
          },
        ];
      } else {
        newCartData.relatedParty = [
          {
            id:
              selectedCustomer && selectedCustomer.ban
                ? selectedCustomer.ban
                : "",
            partyId: selectedCustomer.partyId,
            firstName: selectedCustomer.firstName,
            lastName: selectedCustomer.lastName,
            role:
              selectedCustomer && selectedCustomer.role
                ? selectedCustomer.role
                : "",
          },
        ];
      }

      if (
        this.props.shoppingCart &&
        Array.isArray(this.props.shoppingCart) &&
        this.props.shoppingCart.length > 0 &&
        this.props.shoppingCart[0].cartItem
      ) {
        newCartData.cartItem[0].index =
          this.props.shoppingCart[0].cartItem[
            (newCartData.cartItem[0].index =
              this.props.shoppingCart[0].cartItem.length - 1)
          ].index + 1;
        BusApiCall(
          "PATCH",
          `${constants.busPublicServiceUrl}/shoppingCart/${this.props.shoppingCart[0].id}`,
          newCartData,
        )
          .then((res) => {
            sessionStorage.removeItem("publicCart");
            if (res.data.code && res.data.code === "500") {
              this.props.setErrorMessage(res.data.reason, false);
              this.setState({
                loading: false,
              });
            } else {
              this.props.setCart(res.data);
              if (selectedCustomer.childFirstName) {
                this.getCustomerCart(selectedCustomer.partyId);
              } else {
                this.getCustomerCart(
                  selectedCustomer.partyId,
                  selectedCustomer.ban,
                );
              }
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      } else {
        newCartData.cartItem[0].index = 0;
        BusApiCall(
          "POST",
          `${constants.busPublicServiceUrl}/shoppingCart`,
          newCartData,
        )
          .then((res) => {
            sessionStorage.removeItem("publicCart");
            if (res.data.code && res.data.code === "500") {
              this.props.setErrorMessage(res.data.reason, false);
              this.setState({ loading: false });
            } else {
              this.props.setCart(res.data);
              // this.getCustomerCart(selectedCustomer.partyId);
              if (selectedCustomer.childFirstName) {
                this.getCustomerCart(selectedCustomer.partyId);
              } else {
                this.getCustomerCart(
                  selectedCustomer.partyId,
                  selectedCustomer.ban,
                );
              }
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
  };

  resetSelecteddata = () => {
    // this.setState({
    //     customerDetails: {},
    //     selectedTreeItems: [],
    //     selectedPaymentMethod: null
    // })
  };

  closeDialog = () => {
    if (this.state.customerDetails && this.state.customerDetails.partyId) {
      this.setState({
        showSelectCustomer: false,
      });
      sessionStorage.removeItem("publicCart");
    } else {
      this.props.router.navigate("/newOrder");
    }
  };

  changeCustomer = () => {
    this.setState({
      showSelectCustomer: true,
    });
  };

  checkFulfillable = (value) => {
    if (value === false) {
      return false;
    } else {
      return true;
    }
  };

  confirmQuote = (note) => {
    if (!this.state.notes) {
      if (this.props.priceSummaryView && this.state.mode === "/quote") {
        this.setState((prevState) => ({
          error: {
            ...prevState.error,
            note: this.props.t("NO_NOTE_ADDED"),
          },
        }));
      } else {
        this.props.setErrorMessage(this.props.t("NO_NOTE_ADDED"), false);
      }
    } else {
      this.setState({
        loading: true,
      });
      var payload = {
        // statusId: 'QUO_REVIEW',
        note: {
          text: this.state.notes,
        },
      };
      if (
        this.state.cartData &&
        this.state.cartData.length > 0 &&
        this.state.cartData[0].id
      ) {
        BusApiCall(
          "PUT",
          `${constants.busV44UrlPublic}/quote/${this.state.cartData[0].id}/updateStatus`,
          payload,
        )
          .then((res) => {
            if (note) {
              this.props.setErrorMessage(
                this.props.t("NOTE_ADDED_SUCCESSFULLY"),
                true,
              );
            } else {
              this.props.setErrorMessage(
                this.props.t("QUOTE_DATA_UPDATED"),
                true,
              );
            }
            this.setState({
              notes: "",
            });
            if (this.state.customerDetails.childFirstName) {
              this.getCustomerQuote(this.state.customerDetails.partyId);
            } else {
              this.getCustomerQuote(
                this.state.customerDetails.partyId,
                this.state.customerDetails.ban,
              );
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
  };

  calculatePrices() {
    let dueNowTotal = 0;
    let dueAtInstallationTotal = 0;
    let recurringTotal = 0;
    let cancellationPriceTotal = 0;
    var updatedList = [];
    var NTC_List = [];

    const cartData = this.state.cartData;
    cartData.forEach((item) => {
      item.cartItem.forEach((cartItem) => {
        cartItem.productOffering.includedItems.forEach((includedItem) => {
          includedItem.otherPrices &&
            includedItem.otherPrices.length > 0 &&
            includedItem.otherPrices.forEach((price) => {
              switch (price.priceType) {
                case "ADVANCE":
                case "DEPOSIT":
                  dueNowTotal +=
                    price.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity;
                  break;
                case "SETUP_FEE":
                  dueAtInstallationTotal +=
                    price.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity;
                  break;
                case "RC":
                  recurringTotal +=
                    price.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity;
                  break;
                case "CANCELLATION_PRICE":
                  cancellationPriceTotal +=
                    price.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity;
                  break;
                case "USAGE_CHARGE":
                  var key = `${price.priceTenure}_${price.priceTenureUOM}`;
                  var found = false;
                  for (var k = 0; k < updatedList.length; k++) {
                    if (updatedList[k].key === key) {
                      updatedList[k].price +=
                        price.price *
                        includedItem.quantity *
                        cartItem.productOffering.quantity;
                      found = true;
                      break;
                    }
                  }
                  if (!found) {
                    var newObj = {
                      key: key,
                      termPeriod: price.priceTenure,
                      tenureUom: price.priceTenureUOM,
                      price:
                        price.price *
                        includedItem.quantity *
                        cartItem.productOffering.quantity,
                    };
                    updatedList.push(newObj);
                  }
                  break;
                default:
                  break;
              }
            });
        });
      });
    });
    cartData.forEach((item) => {
      item.cartItem.forEach((cartItem) => {
        cartItem.productOffering.includedItems.forEach((includedItem) => {
          if (includedItem.priceType === "RC") {
            if (includedItem.priceTerm) {
              var key = `${includedItem.priceTerm.termPeriod}_${includedItem.priceTerm.termUomId}`;
              var found = false;
              for (var k = 0; k < updatedList.length; k++) {
                if (updatedList[k].key === key) {
                  updatedList[k].price +=
                    includedItem.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity;
                  found = true;
                  break;
                }
              }
              if (!found) {
                var newObj = {
                  key: key,
                  termPeriod: includedItem.priceTerm.termPeriod,
                  tenureUom: includedItem.priceTerm.termUomId,
                  price:
                    includedItem.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity,
                };
                updatedList.push(newObj);
              }
            }

            // this.setState({ priceRecuringChargeTotal: updatedList });
          } else if (includedItem.priceType === "NTC") {
            if (includedItem.priceTerm) {
              var key = `${includedItem.priceTerm.termPeriod}_${includedItem.priceTerm.termUomId}`;
              var found = false;
              for (var k = 0; k < NTC_List.length; k++) {
                if (NTC_List[k].key === key) {
                  NTC_List[k].price +=
                    includedItem.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity;
                  found = true;
                  break;
                }
              }
              if (!found) {
                var newObj = {
                  key: key,
                  termPeriod: includedItem.priceTerm.termPeriod,
                  tenureUom: includedItem.priceTerm.termUomId,
                  price:
                    includedItem.price *
                    includedItem.quantity *
                    cartItem.productOffering.quantity,
                };
                NTC_List.push(newObj);
              }
            }
          } else {
            dueAtInstallationTotal +=
              includedItem.price *
              includedItem.quantity *
              cartItem.productOffering.quantity;
          }
        });
      });
    });
    this.setState(
      {
        priceDueNow: dueNowTotal,
        priceDueAtInstallation: dueAtInstallationTotal,
        priceRecuringChargeTotal: updatedList,
        cancellationPriceTotal: cancellationPriceTotal,
        priceNTCtotal: NTC_List,
      },
      () => { },
    );
  }

  changeNotes = (e) => {
    this.props.setErrorMessage("", false);
    if (e.target.value.length < 2001) {
      this.setState({
        notes: e.target.value,
      });
    } else {
      this.props.setErrorMessage(this.props.t("MAX_2000_CHARACTER_ERROR"));
    }
  };

  verifyQuote = (status) => {
    this.setState({
      loading: true,
    });
    var payload = {
      statusId: status,
      note: {
        text: this.state.notes,
      },
    };
    BusApiCall(
      "PUT",
      `${constants.busV44UrlPublic}/quote/${this.state.cartData[0].id}/updateStatus`,
      payload,
    )
      .then((res) => {
        this.props.setErrorMessage(this.props.t("QUOTE_STATUS_UPDATED"), true);
        this.setState({
          notes: "",
        });
        if (this.state.customerDetails.childFirstName) {
          this.getCustomerQuote(this.state.customerDetails.partyId);
        } else {
          this.getCustomerQuote(
            this.state.customerDetails.partyId,
            this.state.customerDetails.ban,
          );
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  createOrder = () => {
    var preSelectedPaymentMethod = JSON.parse(
      localStorage.getItem("preSelectedPaymentMethod"),
    );
    let paymentMethodId = null;
    if (
      this.state.customerDetails.paymentMethod.creditCards &&
      this.state.customerDetails.paymentMethod.creditCards.length > 0
    ) {
      paymentMethodId =
        this.state.customerDetails.paymentMethod.creditCards[0].paymentMethodId;
    } else if (
      this.state.customerDetails.paymentMethod.eftAccount &&
      this.state.customerDetails.paymentMethod.eftAccount.length > 0
    ) {
      paymentMethodId =
        this.state.customerDetails.paymentMethod.eftAccount[0].paymentMethodId;
    } else if (this.state.customerDetails.paymentMethod) {
      paymentMethodId =
        this.state.customerDetails.paymentMethod.paymentMethodId;
    }
    var payload = {
      action: "CREATE_ORDER",
      userData: [
        {
          name: "PORTAL_SEND_TNC_EMAIL",
          value:
            this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
              this.props.loggedInUserType === "ECOMMERCE_ADMIN"
              ? "false"
              : "true",
        },
        {
          name: "ORDER_ORIGINATOR",
          value: "Portal",
        },
        {
          name: "ORDER_CREATED_BY",
          value: this.props.providerType,
        },
        {
          name: "shipmentMethodTypeId",
          value: this.state.shipmentMethodTypeId.split("|")[0].trim(),
        },
        {
          name: "carrierPartyId",
          value: this.state.shipmentMethodTypeId.split("|")[1].trim(),
        },
      ],
      agentCode: "",
      note: [
        {
          text: this.state.notes,
        },
      ],
      relatedParty: [
        {
          id: this.state.customerDetails.ban + "",
          role: this.state.customerDetails.role,
        },
      ],
    };
    if (
      this.state.customerDetails.billing &&
      this.state.customerDetails.billing.postalMechId
    ) {
      payload.billingContactMechId =
        this.state.customerDetails.billing.postalMechId;
    } else {
      payload.billingContactMechId = "";
    }
    if (
      this.state.customerDetails.shipping &&
      this.state.customerDetails.shipping.postalMechId
    ) {
      payload.shippingContactMechId =
        this.state.customerDetails.shipping.postalMechId;
    } else {
      payload.shippingContactMechId = "";
    }

    if (paymentMethodId) {
      payload.payment = [
        {
          id: paymentMethodId,
        },
      ];
    } else {
      payload.payment = [];
    }
    this.setState({
      loading: true,
    });
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/quote/${this.state.cartData[0].id}`,
      payload,
    )
      .then((res) => {
        this.setState({
          loading: false,
        });
        if (res.data.orderId) {
          this.props.router.navigate("/order/" + res.data.orderId);
        }
        if (this.state.customerDetails.childFirstName) {
          this.getCustomerQuote(this.state.customerDetails.partyId);
        } else {
          this.getCustomerQuote(
            this.state.customerDetails.partyId,
            this.state.customerDetails.ban,
          );
        }
        this.props.setErrorMessage(
          this.props.t("ORDER_INITIATED_FOR_QUOTE"),
          true,
        );
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  setShipmentMethodTypeId = (e) => {
    this.setState({
      shipmentMethodTypeId: e.target.value,
    });
  };

  getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "TF_hr") {
      return "Hour";
    } else if (val === "DATA_MB") {
      return "MB";
    } else if (val === "DATA_GB") {
      return "GB";
    } else {
      return "";
    }
  };

  showActionDialog = () => {
    if (
      this.state.cartData[0].quoteStatus === "QUO_WAIT_ORDER" &&
      this.state.cartData[0].customer.isTempCustCode
    ) {
      this.setState({
        showBanDialog: true,
      });
    } else {
      this.setState(
        {
          actionDialog: true,
        },
        () => { },
      );
    }
  };

  closeBanDialog = () => {
    this.setState({
      showCustomerBanError: false,
      showBanDialog: false,
    });
  };

  createCustomerBan = () => {
    if (
      this.state.cartData[0].customer.tempCustCodePrefix &&
      this.state.custCodeValue
        .toLowerCase()
        .startsWith(
          this.state.cartData[0].customer.tempCustCodePrefix.toLowerCase(),
        )
    ) {
      this.setState({
        showCustomerBanError: true,
      });
      return;
    }
    if (this.state.custCodeValue.trim()) {
      this.setState({ loading: true });
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/customers/${this.state.custCodeValue}/validate`,
        {},
      )
        .then((res) => {
          if (res && res.data) {
            if (res.data.apiEnabled === "Y") {
              if (
                // res.data.code === 200 &&
                (res.data.status === "Active" || res.data.status === "active" ||
                  res.data.status === "Qualified" || res.data.status === "qualified")
              ) {
                // Allow to create
                this.submitCustomerBan();
                this.setState({
                  showBanDialog: false,
                });
              } else {
                // not allowed
                this.props.setErrorMessage(
                  this.props.t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
                  false,
                );
                this.setState({
                  showBanDialog: false,
                  loading: false,
                  custCodeValue: "",
                });
              }
            } else {
              // Allow to create
              this.submitCustomerBan();
              this.setState({
                showBanDialog: false,
              });
            }
          } else {
            // not allowed
            this.props.setErrorMessage(
              this.props.t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
              false,
            );
            this.setState({
              showBanDialog: false,
              loading: false,
              custCodeValue: "",
            });
          }
        })
        .catch((err) => {
          // not allowed
          // this.props.setErrorMessage(this.props.t('BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER'), false);
          var msg = `${err.response.data.detail ? `${err.response.data.detail} : ` : ""}${err.response.data.message || ""}`;
          this.props.setErrorMessage(msg, false);
          this.setState({
            showBanDialog: false,
            loading: false,
            custCodeValue: "",
          });
        });
    }
  };

  submitCustomerBan = () => {
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/customers/${this.state.custCodeValue}/client/${this.state.cartData[0].customer.clientId}/updateCustomerBAN`,
    )
      .then((res) => {
        this.getCustomerQuote(
          this.state.cartData[0].customer.clientId,
          this.state.customerDetails.ban,
        );
        this.setState({
          custCodeValue: "",
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  changeCustomerBan = (e) => {
    this.setState({
      showCustomerBanError: false,
      [e.target.name]: e.target.value,
    });
  };

  closeActionDialog = (val) => {
    if (val) {
      var tempCartData = this.state.cartData[0];
      this.setState({
        loading: true,
      });
      var tenantId = "";
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        tenantId = localStorage.getItem("selectedSalesChannel");
      }
      val.properties.push({
        id: "accessToken",
        value: this.props.accessToken,
      });
      val.properties.push({
        id: "customerBan",
        value: this.state.customerDetails.ban,
      });
      if (val.uploadedFilesData && val.uploadedFilesData.length > 0) {
        var uploadedFilesData = [];
        for (var i = 0; i < val.uploadedFilesData.length; i++) {
          var fileItem = {
            document: [
              {
                id: "upload",
                value: val.uploadedFilesData[i].fileData,
              },
              {
                id: "uploadedFileName",
                value: val.uploadedFilesData[i].uploadedFileName,
              },
              {
                id: "uploadedFileMimeType",
                value: val.uploadedFilesData[i].uploadedFileMimeType,
              },
              {
                id: "uploadedFileTaskId",
                value: val.uploadedFilesData[i].uploadedFileTaskId,
              },
              {
                id: "isPublic",
                value: val.uploadedFilesData[i].isPublic ? "Y" : "N",
              },
            ],
          };
          uploadedFilesData.push(fileItem);
          if (i === val.uploadedFilesData.length - 1) {
            val.properties.push({
              id: "uploadedFiles",
              value: JSON.stringify(uploadedFilesData),
            });
          }
        }
      }
      // for (var i = 0; i < val.properties.length; i++) {
      //     if (val.properties[i].fileData) {
      //         val.properties[i].value = val.properties[i].fileData;
      //         delete val.properties[i].fileData;
      //     }
      // }
      if (this.state.is_order_status) {
        var payload = {};
        payload = val;
        if (tenantId) {
          payload.tenantId = tenantId;
        }
        // payload = {
        //     [val.properties[0].id]: val.properties[0].value
        // }
        console.log("final payload", payload);
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/flowable/bpmn/resumeDeadProcess?processInstanceId=${this.state.formFields.processInstanceId}`,
          payload,
        )
          .then((res) => {
            this.props.setErrorMessage(this.props.t("QUOTE_DATA_UPDATED"));
            this.setState(
              {
                actionDialog: false,
                // loading: false
              },
              () => {
                this.getQuoteData();
              },
            );
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ loading: false });
          });
      } else {
        var payload = {};
        payload = val;
        if (tenantId) {
          val.tenantId = tenantId;
        }
        payload.properties.push(
          {
            id: "userLoginId",
            value: this.props.loggedInUserId,
          },
          {
            id: "userLoginName",
            value: this.props.loggedInUserName
              ? this.props.loggedInUserName
              : this.props.providerName,
          },
        );
        delete payload.uploadedFilesData;
        var uploadIndex = payload.properties.findIndex(
          (x) => x.id === "upload",
        );
        if (uploadIndex > -1) {
          payload.properties.splice(uploadIndex, 1);
        }
        console.log("final payload", payload, tempCartData);
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/flowable/bpmn/taskForms`,
          payload,
        )
          .then((res) => {
            if (this.state.notes) {
              this.confirmQuote();
            } else {
              this.setState(
                {
                  actionDialog: false,
                  // loading: false
                },
                () => {
                  var tIndex = payload.properties.findIndex(
                    (item) => item.id === "submitForOrder",
                  );
                  if (tIndex > -1) {
                    this.props.router.navigate("/quote/" + tempCartData.id);
                  } else {
                    this.getQuoteData();
                  }
                },
              );
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ loading: false });
          });
      }
    } else {
      this.setState({
        actionDialog: false,
      });
    }
  };

  openDiagramDialog = () => {
    window.open(
      `${window.location.origin}/diagram.html?baseUrl=${constants.busV44UrlPublic}&bpmnProcessInstanceId=${this.state.bpmnProcessInstanceId}&quoteId=${this.state.id}&type=quote`,
      "_blank",
    );
  };

  addOfferings = () => {
    if (window.location.pathname === "/cart") {
      this.props.router.navigate({ pathname: `/newOrder`, state: "checkout" });
    } else {
      var quoteData = this.state.cartData[0];
      var lastIndex =
        quoteData.cartItem[quoteData.cartItem.length - 1].index + 1;
      var obj = {
        ban: this.state.customerDetails.ban,
        // partyId: (childItemDetails && childItemDetails.partyId) ? childItemDetails.partyId : customer.partyId,
        partyId: this.state.customerDetails.partyId,
        // customerId: customer.partyId,
        // orderId: item.orderId,
        subscriptionId: null,
        firstName: this.state.customerDetails.firstName,
        lastName: this.state.customerDetails.lastName,
        // role: customer.role,
        mode: "NewActivation",
        productCode: quoteData.cartItem[0].productOffering.id,
        id: quoteData.id,
        index: lastIndex,
        oldQuote: true,
      };
      this.props.router.navigate({
        pathname: "/newOrder",
        state: obj,
      });
    }
  };

  numbersOnly = (e) => {
    // List of keys to block: +, -, e, E
    if (["+", "-", "e", "E"].includes(e.key)) {
      e.preventDefault(); // Block the key
    }
  };

  showFullNote = (note) => {
    this.setState({
      noteData: note,
      showNote: true,
    });
  };

  closeFullNote = () => {
    this.setState({
      noteData: {},
      showNote: false,
    });
  };

  handleOpenAllNotes = () => {
    this.setState({
      allNotesOpen: true,
    });
  };

  handleCloseAllNotes = () => {
    this.setState({
      allNotesOpen: false,
    });
  };

  openProductSpecification = (offering, product) => {
    // this.setState({
    //     selectedProductSpecificationOffering: offering,
    //     selectedProductSpecification: product,
    //     showProductSpecification: true,
    // })
    var oldData = [...this.state.cartData];
    var cartItem = oldData[0].cartItem;
    var index = cartItem.findIndex((x) => x.index === offering.index);
    var selectedCartItem = cartItem[index];
    var productIndex = selectedCartItem.productOffering.includedItems.findIndex(
      (x) => x.id === product.id,
    );
    var selectedProduct =
      selectedCartItem.productOffering.includedItems[productIndex];
    if (selectedProduct.expandChar) {
      selectedProduct.expandChar = false;
    } else {
      selectedProduct.expandChar = true;
    }
    selectedCartItem.productOffering.includedItems[productIndex] =
      selectedProduct;
    cartItem[index] = selectedCartItem;
    oldData[0].cartItem = cartItem;
    this.setState({
      cartData: oldData,
    });
  };

  handleCloseSpecificationDialog = () => {
    // this.setState({
    //     selectedProductSpecificationOffering: {},
    //     selectedProductSpecification: {},
    //     showProductSpecification: false,
    // });
  };

  handleCharacteristicsUpdate = (updatedCharacteristics, offering, product) => {
    this.setState({ loading: true });
    if (
      updatedCharacteristics &&
      updatedCharacteristics.length > 0 &&
      offering &&
      product
    ) {
      var oldData = [...this.state.cartData];
      var cartItem = oldData[0].cartItem;
      var index = cartItem.findIndex((x) => x.index === offering.index);
      var selectedCartItem = cartItem[index];
      var productIndex =
        selectedCartItem.productOffering.includedItems.findIndex(
          (x) => x.id === product,
        );
      var selectedProduct =
        selectedCartItem.productOffering.includedItems[productIndex];
      if (selectedProduct.productSpec && selectedProduct.productSpec.category) {
        // if (selectedProduct.productSpec.category.id === 'PSC_CUST_FACING') {
        selectedProduct.productCharsOverride = [];
        updatedCharacteristics.map((char) =>
          selectedProduct.productCharsOverride.push({
            name: char.name,
            value: char.value,
            specId: char.specId,
            id: char.id,
          }),
        );
        // }
      }
      selectedCartItem.productOffering.includedItems[productIndex] =
        selectedProduct;
      selectedCartItem.action = "MODIFY";
      var payload = {
        cartItem: [],
      };
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        payload.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      payload.cartItem.push(selectedCartItem);
      BusApiCall(
        "PATCH",
        `${constants.busPublicServiceUrl}/shoppingCart/${this.state.cartData[0].id}`,
        payload,
      )
        .then((res) => {
          this.props.setErrorMessage(
            this.props.t("CHARACTERISTIC_UPDATED_SUCCESSFULLY"),
            true,
          );
          if (this.state.customerDetails.childFirstName) {
            this.getCustomerCart(this.state.customerDetails.partyId);
          } else {
            this.getCustomerCart(
              this.state.customerDetails.partyId,
              this.state.customerDetails.ban,
            );
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    }
  };

  // Render cart view
  render() {
    // Calculate and fetch total amoutn of items
    const { nowTotal, recTotal } = totalCalculator(
      this.props.componentList,
      this.props.solutionList,
      this.props.accessoryList,
      this.props.tenantId,
    );
    const { t } = this.props;
    const customerData = { ...this.state.customerDetails };
    const { classes: jssClasses } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container spacing={1}>
              <Grid
                item
                size={{
                  xs: 4,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              <Grid
                item
                align="right"
                style={{ paddingRight: "1rem" }}
                size={{
                  xs: 8,
                }}
              >
                {this.state.customerDetails &&
                  this.state.customerDetails.accountName && (
                    <h3
                      className={classes.customBreadcrumb}
                      style={{
                        margin: 0,
                        fontWeight: "normal",
                        float: "right",
                      }}
                    >
                      {this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                        this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                        ? t("SELECT_SHIPPING_ADDRESS")
                        : t("SELECT_CUSTOMER")}
                      :&nbsp;
                      <span
                        title={this.state.customerDetails.canonicalName}
                        style={{
                          fontWeight: "bold",
                          color: this.props.tenantData.color,
                          cursor: "pointer",
                        }}
                        onClick={() => this.changeCustomer()}
                      >
                        {/* {this.state.customerDetails.accountName} */}
                        {this.state.customerDetails.childAccountName
                          ? this.state.customerDetails.childAccountName
                          : this.state.customerDetails.canonicalName}
                        <EditIcon
                          style={{
                            position: "absolute",
                            fontSize: "20px",
                            marginLeft: "5px",
                          }}
                        />
                      </span>
                    </h3>
                  )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {this.state.mode === "/quote" && (
                  <div
                    style={{
                      display: "flex",
                      gap: ".5rem",
                      alignItems: "center",
                    }}
                  >
                    {this.state.cartData &&
                      this.state.cartData[0] &&
                      this.state.cartData[0].typeDescription &&
                      this.state.cartData[0].typeDescription !== "" && (
                        <h2 style={{ fontSize: "15px", fontWeight: "bold" }}>
                          {this.props.t("TYPE")}:{" "}
                          {this.state.cartData[0].typeDescription}
                        </h2>
                      )}

                    <h2 style={{ fontSize: "15px", fontWeight: "normal" }}>
                      {this.state.cartData &&
                        this.state.cartData.length > 0 &&
                        this.state.cartData[0].quoteStatus && (
                          <b>
                            {/* {this.state.cartData[0].quoteStatus === 'QUO_REVIEW' &&
                                                        <>
                                                            {t('STATUS')}: {t('QUOTE_SUBMITTED_FOR_REVIEW')}
                                                        </>
                                                    }
                                                    {this.state.cartData[0].quoteStatus === 'QUO_CREATED' &&
                                                        <>
                                                            {t('STATUS')}: {t('QUOTE_CREATED')}
                                                        </>
                                                    }
                                                    {this.state.cartData[0].quoteStatus === 'QUO_APPROVED' &&
                                                        <>
                                                            {t('STATUS')}: {t('QUOTE_APPROVED')}
                                                        </>
                                                    }
                                                    {this.state.cartData[0].quoteStatus === 'QUO_REJECTED' &&
                                                        <>
                                                            {t('STATUS')}: {t('QUOTE_REJECTED')}
                                                        </>
                                                    } */}
                            {/* {t("STATUS")}: {this.state.cartData[0].quoteStatusDescription} */}
                            {this.state.cartData[0].quoteStatusDescription && (
                              <Chip
                                size="normal"
                                className="inProgressChip"
                                label={
                                  this.state.cartData[0].quoteStatusDescription
                                }
                              />
                            )}
                          </b>
                        )}
                    </h2>
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ paddingLeft: "1rem", paddingRight: ".75rem" }}>
          <Grid
            container
            spacing={8}
            justifyContent="center"
            style={{ width: "100%" }}
          >
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <div className={classes.cartDiv}>
                <div className={classes.cartButtonsDiv}>
                  {this.state.mode === "/quote" ? (
                    this.state.cartData &&
                      this.state.cartData.length > 0 &&
                      this.state.cartData[0].quoteStatus !== "QUO_REVIEW" &&
                      this.state.cartData[0].quoteStatus !== "QUO_APPROVED" &&
                      this.state.cartData[0].quoteStatus !== "QUO_ORDERED" &&
                      this.state.cartData[0].quoteStatus !== "QUO_WAIT_ORDER" ? (
                      <Button
                        onClick={() => {
                          this.props.setErrorMessage("");
                          this.props.clearCart();
                          this.showClearCartWarning();
                          this.props.setPromoBan("");
                        }}
                        className={classes.clearCartButton + " buttonSecondary"}
                        disabled={this.state.disableCheckout}
                      >
                        {t("CANCEL_QUOTE")}
                      </Button>
                    ) : (
                      <Button
                        className={classes.clearCartButton + " buttonSecondary"}
                        disabled={true}
                      >
                        {t("CANCEL_QUOTE")}
                      </Button>
                    )
                  ) : (
                    <Button
                      onClick={() => {
                        this.props.setErrorMessage("");
                        this.props.clearCart();
                        this.showClearCartWarning();
                        this.props.setPromoBan("");
                      }}
                      className={classes.clearCartButton + " buttonSecondary"}
                      disabled={this.state.disableCheckout}
                    >
                      {t("CLEAR_CART")}
                    </Button>
                  )}
                  <div>
                    {this.props.publicBrowsing ? (
                      <>
                        <Button
                          onClick={() => {
                            this.props.setErrorMessage("");
                            this.props.router.navigate("/solutions");
                          }}
                          className={classes.contButton}
                        >
                          {t("CONTINUE_SHOPPING")}
                        </Button>
                      </>
                    ) : (
                      <>
                        {this.state.mode === "/quote" ? (
                          this.state.cartData &&
                            (this.state.cartData.length === 0 ||
                              (this.state.cartData.length > 0 &&
                                this.state.cartData[0].quoteStatus !==
                                "QUO_REVIEW" &&
                                this.state.cartData[0].quoteStatus !==
                                "QUO_APPROVED" &&
                                this.state.cartData[0].quoteStatus !==
                                "QUO_ORDERED" &&
                                this.state.cartData[0].quoteStatus !==
                                "QUO_WAIT_ORDER")) ? (
                            <Button
                              onClick={() => {
                                this.props.setErrorMessage("");
                                this.props.router.navigate("/newOrder");
                              }}
                              className={classes.contButton}
                            >
                              {t("CONTINUE_SHOPPING")}
                            </Button>
                          ) : (
                            <Button
                              disabled={true}
                              className={classes.contButton}
                            >
                              {t("CONTINUE_SHOPPING")}
                            </Button>
                          )
                        ) : (
                          <Button
                            onClick={() => {
                              this.props.setErrorMessage("");
                              this.props.router.navigate("/newOrder");
                            }}
                            className={classes.contButton}
                          >
                            {t("CONTINUE_SHOPPING")}
                          </Button>
                        )}
                      </>
                    )}

                    {this.state.mode === "/cart" && (
                      <Button
                        disabled={this.state.disableCheckout}
                        onClick={() => {
                          this.props.getUnApprovedItemList();
                          setTimeout(() => {
                            if (
                              this.props.accessoryList.length > 0 ||
                              this.props.solutionList.length > 0 ||
                              (this.state.cartData &&
                                this.state.cartData.length > 0)
                            ) {
                              if (
                                this.props.unApprovedArraySol &&
                                this.props.unApprovedArrayAcc &&
                                (this.props.unApprovedArraySol.length > 0 ||
                                  this.props.unApprovedArrayAcc.length > 0)
                              ) {
                                this.setState({
                                  open: true,
                                });
                              } else {
                                {
                                  this.props.publicBrowsing
                                    ? this.callCheckoutLogin()
                                    : this.props.router.navigate("/checkout");
                                }
                              }
                            } else {
                              this.props.setErrorMessage(t("NO_ITEM_IN_CART"));
                            }
                          }, 500);
                        }}
                        className={classes.checkOutButton}
                      >
                        {t("CHECKOUT")}
                      </Button>
                    )}

                    {/* Non approved items alert box */}
                    <Dialog
                      fullWidth={true}
                      maxWidth={"sm"}
                      open={this.state.open}
                      onClose={this.handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogContent>
                        <div>
                          {t("SOLUTIONS_NOT_APPROVED_ERROR")}
                          {this.props.unApprovedArraySol && (
                            <ul>
                              {this.props.unApprovedArraySol.map(
                                (row, index) => (
                                  <li key={index}>{row.name}</li>
                                ),
                              )}
                            </ul>
                          )}
                          {this.props.unApprovedArrayAcc && (
                            <ul>
                              {this.props.unApprovedArrayAcc.map(
                                (row, index) => (
                                  <li key={index}>{row.name}</li>
                                ),
                              )}
                            </ul>
                          )}
                        </div>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                          {t("BACK")}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </div>

                {/* Show customer info for quote */}
                {this.state.mode === "/quote" &&
                  this.state.cartData &&
                  this.state.cartData.length > 0 &&
                  this.state.cartData[0].customer &&
                  this.state.cartData[0].customer.ban && (
                    <div style={{ color: "#000", marginBottom: "25px" }}>
                      <CustomerDetailBlock
                        editOption={false}
                        stage={{}}
                        edit={() => { }}
                        customerDetails={this.state.cartData[0].customer}
                      />
                    </div>
                  )}
                {this.state.cartData && this.state.cartData.length > 0 && (
                  <Grid
                    item
                    style={{ display: "flex", justifyContent: "space-between" }}
                    size={{
                      xs: 12,
                      md: 8,
                    }}
                  >
                    <div>
                      <h3
                        style={{ marginTop: 0, color: "rgba(0, 0, 0, 0.87)" }}
                      >
                        {this.state.mode === "/quote"
                          ? this.props.t("QUOTE_ITEMS")
                          : this.props.t("CART_ITEMS")}
                      </h3>
                    </div>
                    {this.state.cartData &&
                      this.state.cartData.length > 0 &&
                      this.state.cartData[0].quoteStatus !== "QUO_REVIEW" &&
                      this.state.cartData[0].quoteStatus !== "QUO_APPROVED" &&
                      this.state.cartData[0].quoteStatus !== "QUO_ORDERED" &&
                      this.state.cartData[0].quoteStatus !==
                      "QUO_WAIT_ORDER" && (
                        <div>
                          <Button
                            onClick={() => {
                              this.addOfferings();
                            }}
                          >
                            <span
                              style={{
                                verticalAlign: "middle",
                                marginRight: ".25rem",
                              }}
                            >
                              <PlusIcon />
                            </span>
                            {t("ADD_OFFERINGS")}
                          </Button>
                          <Button
                            onClick={() => {
                              this.updateQuoteData();
                            }}
                            disabled={!this.state.unsavedChanges}
                            style={{ marginLeft: "15px", marginRight: "4px" }}
                          >
                            {/* <span style={{ verticalAlign: "middle", marginRight: ".25rem" }}>
                                                            <PlusIcon />
                                                        </span> */}
                            {this.state.mode === "/quote"
                              ? t("UPDATE_QUOTE")
                              : t("UPDATE_CART")}
                          </Button>
                        </div>
                      )}
                  </Grid>
                )}
                <Grid container spacing={1}>
                  {this.props.priceSummaryView ? (
                    this.state.cartData && this.state.cartData.length > 0 ? (
                      <>
                        <Grid
                          item
                          className={classes.cartItemContainer}
                          size={{
                            xs: 12,
                            md: 8,
                          }}
                        >
                          {/* {this.state.cartData.length > 0 && */}
                          {this.state.cartData[0].cartItem
                            .sort((a, b) => a.index - b.index)
                            .map((item, i) => (
                              <React.Fragment key={i}>
                                <Card
                                  variant="outlined"
                                  className={
                                    "roundCorners " + classes.cartItemCard
                                  }
                                >
                                  <Grid
                                    container
                                    className={classes.cardItemHeader}
                                  >
                                    <Grid
                                      item
                                      size={{
                                        xs: 12,
                                        md: 8,
                                      }}
                                    >
                                      <b>{item.productOffering.name}</b>
                                      {this.state.mode === "/quote" &&
                                        this.state.cartData[0].quoteStatus !==
                                        "QUO_REVIEW" &&
                                        this.state.cartData[0].quoteStatus !==
                                        "QUO_APPROVED" &&
                                        this.state.cartData[0].quoteStatus !==
                                        "QUO_ORDERED" &&
                                        this.state.cartData[0].quoteStatus !==
                                        "QUO_WAIT_ORDER" && (
                                          <Tooltip title={t("EDIT")}>
                                            <IconButton
                                              className="buttonSecondary"
                                              onClick={() =>
                                                this.props.router.navigate(
                                                  "/newOrder/" +
                                                  item.productOffering.id,
                                                  {
                                                    productQuoted:
                                                      item.productOffering,
                                                    quotedCustomer:
                                                      this.state
                                                        .customerDetails,
                                                    quoteData: {
                                                      quoteId: item.id,
                                                      quoteIndex: item.index,
                                                    },
                                                  },
                                                )
                                              }
                                            >
                                              {" "}
                                              <EditIconNew />{" "}
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                    </Grid>
                                    <Grid
                                      item
                                      justifyContent="flex-end"
                                      size={{
                                        xs: 12,
                                        md: 4,
                                      }}
                                    >
                                      {this.state.cartData[0] &&
                                        this.state.cartData[0].quoteStatus !==
                                        "QUO_REVIEW" &&
                                        this.state.cartData[0].quoteStatus !==
                                        "QUO_APPROVED" &&
                                        this.state.cartData[0].quoteStatus !==
                                        "QUO_ORDERED" &&
                                        this.state.cartData[0].quoteStatus !==
                                        "QUO_WAIT_ORDER" ? (
                                        <>
                                          <Input
                                            className={classes.quantityInput}
                                            type="number"
                                            min="1"
                                            step="1"
                                            name="quantity"
                                            value={
                                              item.productOffering.quantity
                                            }
                                            onChange={(e) => {
                                              this.tempChangePSQuantity(
                                                e,
                                                item,
                                              );
                                            }}
                                            onBlur={(e) => {
                                              this.tempChangePSQuantityVerify(
                                                e,
                                                item,
                                              );
                                            }}
                                            style={{
                                              backgroundColor: "#fff",
                                              borderRadius: "5px",
                                            }}
                                            onKeyDown={(e) => {
                                              this.changePSQuantity(e, item);
                                            }}
                                          />
                                          <Tooltip title={t("DELETE")}>
                                            <IconButton
                                              className="buttonSecondary"
                                              onClick={() => {
                                                this.showRemoveItemWarning(
                                                  item,
                                                );
                                              }}
                                            //style={{ marginRight: "15px", marginTop: "4px" }}
                                            >
                                              <DeleteIconNew />
                                            </IconButton>
                                          </Tooltip>
                                          {item.productOffering &&
                                            item.productOffering
                                              .specialPricingCode && (
                                              <Tooltip
                                                title={t(
                                                  "SPECIAL_PRICE_APPLIED",
                                                  item.productOffering,
                                                )}
                                              >
                                                <IconButton className="buttonSecondary">
                                                  <MoneyOffIcon fontSize="small" />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                        </>
                                      ) : (
                                        <>
                                          <Input
                                            className={classes.quantityInput}
                                            type="number"
                                            min="1"
                                            step="1"
                                            name="quantity"
                                            value={
                                              item.productOffering.quantity
                                            }
                                            onChange={(e) => {
                                              this.tempChangePSQuantity(
                                                e,
                                                item,
                                              );
                                            }}
                                            onBlur={(e) => {
                                              this.tempChangePSQuantityVerify(
                                                e,
                                                item,
                                              );
                                            }}
                                            style={{
                                              backgroundColor: "#fff",
                                              borderRadius: "5px",
                                            }}
                                            onKeyDown={(e) => {
                                              this.changePSQuantity(e, item);
                                            }}
                                            disabled
                                          />
                                        </>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <div className={classes.includedItemsTable}>
                                    <TableContainer>
                                      <Table className="newGlobalTable roundCorners">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell
                                              colSpan={
                                                this.props.providerType ===
                                                  "SALES_CHNL_PROVIDER"
                                                  ? 1
                                                  : 4
                                              }
                                            >
                                              {t("ITEM_DESCRIPTION")}
                                            </TableCell>
                                            {this.props.providerType ===
                                              "SALES_CHNL_PROVIDER" && (
                                                <>
                                                  <TableCell
                                                    align="right"
                                                    style={{ width: "120px" }}
                                                  >
                                                    {t("QUANTITY")}
                                                  </TableCell>
                                                  <TableCell
                                                    align="right"
                                                    style={{ width: "200px" }}
                                                  >
                                                    {t("UNIT_PRICE")}
                                                  </TableCell>
                                                  <TableCell
                                                    align="right"
                                                    style={{ width: "200px" }}
                                                  >
                                                    {t("TOTAL_PRICE")}
                                                  </TableCell>
                                                </>
                                              )}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {!item.productOffering.sellable &&
                                            item.productOffering.includedItems.map(
                                              (aItem, aIndex) =>
                                                this.checkFulfillable(
                                                  aItem.fulfillable,
                                                ) &&
                                                aItem.customerViewable && (
                                                  <>
                                                    <TableRow
                                                      key={aIndex}
                                                      className=""
                                                    >
                                                      <TableCell colSpan={4}>
                                                        {formatNumber(aItem.quantity *
                                                          item.productOffering
                                                            .quantity)}{" "}
                                                        x <b>{aItem.name}</b>
                                                        {aItem.productSpec &&
                                                          aItem.productSpec
                                                            .category && (
                                                            <Tooltip
                                                              title={t(
                                                                "PRODUCT_SPECIFICATION",
                                                              )}
                                                            >
                                                              <span
                                                                onClick={() =>
                                                                  this.openProductSpecification(
                                                                    item,
                                                                    aItem,
                                                                  )
                                                                }
                                                                style={{
                                                                  display:
                                                                    "inline-flex",
                                                                  position:
                                                                    "relative",
                                                                  marginLeft:
                                                                    "10px",
                                                                  top: "3px",
                                                                }}
                                                              >
                                                                <ClipboardWithGear />
                                                              </span>
                                                            </Tooltip>
                                                          )}
                                                      </TableCell>
                                                    </TableRow>
                                                    {this.props.providerType !==
                                                      "SOLUTION_PROVIDER" &&
                                                      (aItem.recurringCost?.some(
                                                        (charge) =>
                                                          charge.price > 0,
                                                      ) ||
                                                        Number(
                                                          aItem.specialPrice ||
                                                          aItem.price ||
                                                          aItem.depositPrice ||
                                                          aItem.setupFee,
                                                        ) > 0 ||
                                                        aItem.otherPrices?.some(
                                                          (op) =>
                                                            Number(op.price) >
                                                            0,
                                                        )) && (
                                                        <>
                                                          {aItem.nonRecurringCost &&
                                                            Number(
                                                              aItem.nonRecurringCost,
                                                            ) > 0 ? (
                                                            <TableRow>
                                                              <TableCell>
                                                                <span
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  <EnterArrow />
                                                                  {t(
                                                                    "NRC_FULL",
                                                                  )}
                                                                </span>
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ||
                                                                  this.props
                                                                    .publicBrowsing ? (
                                                                  <>
                                                                    {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                )}
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ? (
                                                                  <>
                                                                    {currencyFormatter(
                                                                      aItem.specialPrice
                                                                        ? aItem.specialPrice
                                                                        : aItem.nonRecurringCost,
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  currencyFormatter(
                                                                    0,
                                                                    false,
                                                                  )
                                                                )}
                                                              </TableCell>

                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ? (
                                                                  <>
                                                                    {currencyFormatter(
                                                                      (aItem.specialPrice
                                                                        ? aItem.specialPrice
                                                                        : aItem.nonRecurringCost) *
                                                                      aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity,
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  currencyFormatter(
                                                                    0,
                                                                    false,
                                                                  )
                                                                )}
                                                              </TableCell>
                                                            </TableRow>
                                                          ) : (
                                                            ""
                                                          )}
                                                          {aItem.recurringCost &&
                                                            aItem.recurringCost.map(
                                                              (
                                                                charge,
                                                                index,
                                                              ) => {
                                                                const {
                                                                  key,
                                                                  termPeriod,
                                                                  tenureUom,
                                                                  price,
                                                                } = charge;
                                                                const displayText =
                                                                  termPeriod > 1
                                                                    ? `${t("RC_FULL")} (per ${termPeriod} ${this.getPriceTenureUOM(tenureUom)}s)`
                                                                    : `${t("RC_FULL")} (per ${this.getPriceTenureUOM(tenureUom)})`;

                                                                return (
                                                                  price > 0 && (
                                                                    <TableRow
                                                                      key={
                                                                        index
                                                                      }
                                                                    >
                                                                      <TableCell>
                                                                        <span
                                                                          style={{
                                                                            display:
                                                                              "flex",
                                                                            alignItems:
                                                                              "center",
                                                                          }}
                                                                        >
                                                                          <EnterArrow />
                                                                          {
                                                                            displayText
                                                                          }
                                                                        </span>
                                                                      </TableCell>
                                                                      <TableCell align="right">
                                                                        {this
                                                                          .props
                                                                          .providerType ===
                                                                          "SALES_CHNL_PROVIDER" ||
                                                                          this
                                                                            .props
                                                                            .publicBrowsing ? (
                                                                          <>
                                                                            {formatNumber(aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity)}
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            {formatNumber(aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity)}
                                                                          </>
                                                                        )}
                                                                      </TableCell>
                                                                      <TableCell align="right">
                                                                        {currencyFormatter(
                                                                          aItem.specialPrice
                                                                            ? aItem.specialPrice
                                                                            : price,
                                                                        )}
                                                                      </TableCell>

                                                                      <TableCell align="right">
                                                                        {this
                                                                          .props
                                                                          .providerType ===
                                                                          "SALES_CHNL_PROVIDER" ? (
                                                                          <>
                                                                            {currencyFormatter(
                                                                              (aItem.specialPrice
                                                                                ? aItem.specialPrice
                                                                                : price) *
                                                                              aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity,
                                                                            )}
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            {currencyFormatter(
                                                                              0,
                                                                              false,
                                                                            )}
                                                                          </>
                                                                        )}
                                                                      </TableCell>
                                                                    </TableRow>
                                                                  )
                                                                );
                                                              },
                                                            )}

                                                          {!aItem.nonRecurringCost &&
                                                            !aItem.recurringCost && (
                                                              // (Number(aItem.specialPrice ? aItem.specialPrice : aItem.price) > 0) &&
                                                              <>
                                                                {aItem.priceType !==
                                                                  "RC" &&
                                                                  Number(
                                                                    aItem.specialPrice
                                                                      ? aItem.specialPrice
                                                                      : aItem.price,
                                                                  ) > 0 && (
                                                                    <TableRow>
                                                                      <TableCell>
                                                                        <span
                                                                          style={{
                                                                            display:
                                                                              "flex",
                                                                            alignItems:
                                                                              "center",
                                                                          }}
                                                                        >
                                                                          <EnterArrow />
                                                                          {aItem.priceType ===
                                                                            "NTC"
                                                                            ? aItem
                                                                              .priceTerm
                                                                              .termPeriod >
                                                                              1
                                                                              ? `${t("NTC_FULL")} (per ${this.getPriceTenureUOM(
                                                                                aItem
                                                                                  .priceTerm
                                                                                  .termUomId,
                                                                              )} for ${aItem.priceTerm.termPeriod} ${this.getPriceTenureUOM(
                                                                                aItem
                                                                                  .priceTerm
                                                                                  .termUomId,
                                                                              )}s)`
                                                                              : `${t("NTC_FULL")} (per ${this.getPriceTenureUOM(
                                                                                aItem
                                                                                  .priceTerm
                                                                                  .termUomId,
                                                                              )} for ${aItem.priceTerm.termPeriod} ${this.getPriceTenureUOM(
                                                                                aItem
                                                                                  .priceTerm
                                                                                  .termUomId,
                                                                              )})`
                                                                            : t(
                                                                              "NRC_FULL",
                                                                            )}
                                                                        </span>
                                                                      </TableCell>
                                                                      <TableCell align="right">
                                                                        {this
                                                                          .props
                                                                          .providerType ===
                                                                          "SALES_CHNL_PROVIDER" ||
                                                                          this
                                                                            .props
                                                                            .publicBrowsing ? (
                                                                          <>
                                                                            {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                            {formatNumber(aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity)}
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            {formatNumber(aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity)}
                                                                          </>
                                                                        )}
                                                                      </TableCell>
                                                                      <TableCell align="right">
                                                                        {currencyFormatter(
                                                                          aItem.specialPrice
                                                                            ? aItem.specialPrice
                                                                            : aItem.price,
                                                                        )}
                                                                      </TableCell>

                                                                      <TableCell align="right">
                                                                        {this
                                                                          .props
                                                                          .providerType ===
                                                                          "SALES_CHNL_PROVIDER" ? (
                                                                          <>
                                                                            {currencyFormatter(
                                                                              (aItem.specialPrice
                                                                                ? aItem.specialPrice
                                                                                : aItem.price) *
                                                                              aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity,
                                                                            )}
                                                                          </>
                                                                        ) : (
                                                                          currencyFormatter(
                                                                            0,
                                                                            false,
                                                                          )
                                                                        )}
                                                                      </TableCell>
                                                                    </TableRow>
                                                                  )}
                                                                {aItem.priceType ===
                                                                  "RC" &&
                                                                  Number(
                                                                    aItem.specialPrice
                                                                      ? aItem.specialPrice
                                                                      : aItem.price,
                                                                  ) > 0 && (
                                                                    <TableRow>
                                                                      <TableCell>
                                                                        <span
                                                                          style={{
                                                                            display:
                                                                              "flex",
                                                                            alignItems:
                                                                              "center",
                                                                          }}
                                                                        >
                                                                          <EnterArrow />
                                                                          {t(
                                                                            "RC_FULL",
                                                                          )}
                                                                          {aItem.priceTerm &&
                                                                            (aItem
                                                                              .priceTerm
                                                                              .termPeriod
                                                                              ? aItem
                                                                                .priceTerm
                                                                                .termPeriod >
                                                                                1
                                                                                ? " (" +
                                                                                "per " +
                                                                                aItem
                                                                                  .priceTerm
                                                                                  .termPeriod +
                                                                                " " +
                                                                                this.getPriceTenureUOM(
                                                                                  aItem
                                                                                    .priceTerm
                                                                                    .termUomId,
                                                                                ) +
                                                                                "s" +
                                                                                ")"
                                                                                : " (" +
                                                                                "per " +
                                                                                this.getPriceTenureUOM(
                                                                                  aItem
                                                                                    .priceTerm
                                                                                    .termUomId,
                                                                                ) +
                                                                                ")"
                                                                              : "")}
                                                                        </span>
                                                                      </TableCell>
                                                                      <TableCell align="right">
                                                                        {this
                                                                          .props
                                                                          .providerType ===
                                                                          "SALES_CHNL_PROVIDER" ||
                                                                          this
                                                                            .props
                                                                            .publicBrowsing ? (
                                                                          <>
                                                                            {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                              {formatNumber(aItem.quantity *
                                                                                item
                                                                                  .productOffering
                                                                                  .quantity)}
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            {formatNumber(aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity)}
                                                                          </>
                                                                        )}
                                                                      </TableCell>
                                                                      <TableCell align="right">
                                                                        {currencyFormatter(
                                                                          aItem.specialPrice
                                                                            ? aItem.specialPrice
                                                                            : aItem.price,
                                                                        )}
                                                                      </TableCell>

                                                                      <TableCell align="right">
                                                                        {this
                                                                          .props
                                                                          .providerType ===
                                                                          "SALES_CHNL_PROVIDER" ? (
                                                                          <>
                                                                            {currencyFormatter(
                                                                              (aItem.specialPrice
                                                                                ? aItem.specialPrice
                                                                                : aItem.price) *
                                                                              aItem.quantity *
                                                                              item
                                                                                .productOffering
                                                                                .quantity,
                                                                            )}
                                                                          </>
                                                                        ) : (
                                                                          currencyFormatter(
                                                                            0,
                                                                            false,
                                                                          )
                                                                        )}
                                                                      </TableCell>
                                                                    </TableRow>
                                                                  )}
                                                                {aItem.otherPrices &&
                                                                  aItem
                                                                    .otherPrices
                                                                    .length >
                                                                  0 &&
                                                                  aItem.otherPrices.map(
                                                                    (op, opx) =>
                                                                      Number(
                                                                        aItem.specialPrice
                                                                          ? aItem.specialPrice
                                                                          : op.price,
                                                                      ) > 0 &&
                                                                      op.priceType !==
                                                                      "CANCELLATION_PRICE" && (
                                                                        <TableRow
                                                                          key={
                                                                            opx
                                                                          }
                                                                        >
                                                                          <TableCell>
                                                                            <span
                                                                              style={{
                                                                                display:
                                                                                  "flex",
                                                                                alignItems:
                                                                                  "center",
                                                                              }}
                                                                            >
                                                                              <EnterArrow />
                                                                              {t(
                                                                                op.priceType,
                                                                              )}
                                                                            </span>
                                                                            {op.priceTenure !==
                                                                              null &&
                                                                              op.priceTenureUOM && (
                                                                                <span>
                                                                                  {op.priceTenure >
                                                                                    1
                                                                                    ? ` (per ${op.priceTenure} ${this.getPriceTenureUOM(
                                                                                      op.priceTenureUOM,
                                                                                    )}s)`
                                                                                    : ` (per ${this.getPriceTenureUOM(op.priceTenureUOM)})`}
                                                                                </span>
                                                                              )}
                                                                          </TableCell>
                                                                          <TableCell align="right">
                                                                            {this
                                                                              .props
                                                                              .providerType ===
                                                                              "SALES_CHNL_PROVIDER" ||
                                                                              this
                                                                                .props
                                                                                .publicBrowsing ? (
                                                                              <>
                                                                                {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                                {formatNumber(aItem.quantity *
                                                                                  item
                                                                                    .productOffering
                                                                                    .quantity)}
                                                                              </>
                                                                            ) : (
                                                                              <>
                                                                                {formatNumber(aItem.quantity *
                                                                                  item
                                                                                    .productOffering
                                                                                    .quantity)}
                                                                              </>
                                                                            )}
                                                                          </TableCell>
                                                                          <TableCell align="right">
                                                                            {currencyFormatter(
                                                                              aItem.specialPrice
                                                                                ? aItem.specialPrice
                                                                                : op.price,
                                                                            )}
                                                                          </TableCell>

                                                                          <TableCell align="right">
                                                                            {this
                                                                              .props
                                                                              .providerType ===
                                                                              "SALES_CHNL_PROVIDER" ? (
                                                                              <>
                                                                                {currencyFormatter(
                                                                                  (aItem.specialPrice
                                                                                    ? aItem.specialPrice
                                                                                    : op.price) *
                                                                                  aItem.quantity *
                                                                                  item
                                                                                    .productOffering
                                                                                    .quantity,
                                                                                )}
                                                                              </>
                                                                            ) : (
                                                                              currencyFormatter(
                                                                                0,
                                                                                false,
                                                                              )
                                                                            )}
                                                                          </TableCell>
                                                                          {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                                        </TableRow>
                                                                      ),
                                                                  )}
                                                              </>
                                                            )}
                                                          {aItem.depositPrice &&
                                                            Number(
                                                              aItem.specialPrice
                                                                ? aItem.specialPrice
                                                                : aItem.depositPrice,
                                                            ) > 0 ? (
                                                            <TableRow>
                                                              <TableCell>
                                                                <span
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  <EnterArrow />
                                                                  {t(
                                                                    "DEPOSIT_PRICE",
                                                                  )}
                                                                </span>
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ||
                                                                  this.props
                                                                    .publicBrowsing ? (
                                                                  <>
                                                                    {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                )}
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {currencyFormatter(
                                                                  aItem.specialPrice
                                                                    ? aItem.specialPrice
                                                                    : aItem.depositPrice,
                                                                )}
                                                              </TableCell>

                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ? (
                                                                  <>
                                                                    {currencyFormatter(
                                                                      (aItem.specialPrice
                                                                        ? aItem.specialPrice
                                                                        : aItem.depositPrice) *
                                                                      aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity,
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  currencyFormatter(
                                                                    0,
                                                                    false,
                                                                  )
                                                                )}
                                                              </TableCell>
                                                              {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                            </TableRow>
                                                          ) : (
                                                            ""
                                                          )}
                                                          {aItem.setupFee &&
                                                            Number(
                                                              aItem.specialPrice
                                                                ? aItem.specialPrice
                                                                : aItem.setupFee,
                                                            ) > 0 ? (
                                                            <TableRow>
                                                              <TableCell>
                                                                <span
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  <EnterArrow />
                                                                  {t(
                                                                    "SETUP_FEE",
                                                                  )}
                                                                </span>
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ||
                                                                  this.props
                                                                    .publicBrowsing ? (
                                                                  <>
                                                                    {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                )}
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {currencyFormatter(
                                                                  aItem.specialPrice
                                                                    ? aItem.specialPrice
                                                                    : aItem.setupFee,
                                                                )}
                                                              </TableCell>

                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ? (
                                                                  <>
                                                                    {currencyFormatter(
                                                                      (aItem.specialPrice
                                                                        ? aItem.specialPrice
                                                                        : aItem.setupFee) *
                                                                      aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity,
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  currencyFormatter(
                                                                    0,
                                                                    false,
                                                                  )
                                                                )}
                                                              </TableCell>
                                                              {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                            </TableRow>
                                                          ) : (
                                                            ""
                                                          )}
                                                          {this.props.type ===
                                                            "CancelSubscription" &&
                                                            aItem.cancellationPrice &&
                                                            Number(
                                                              aItem.specialPrice
                                                                ? aItem.specialPrice
                                                                : aItem.cancellationPrice,
                                                            ) > 0 ? (
                                                            <TableRow>
                                                              <TableCell>
                                                                <span
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                  }}
                                                                >
                                                                  <EnterArrow />
                                                                  {t(
                                                                    "CANCELLATION_PRICE",
                                                                  )}
                                                                </span>
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ||
                                                                  this.props
                                                                    .publicBrowsing ? (
                                                                  <>
                                                                    {/* ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)}) */}
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    {formatNumber(aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity)}
                                                                  </>
                                                                )}
                                                              </TableCell>
                                                              <TableCell align="right">
                                                                {currencyFormatter(
                                                                  aItem.specialPrice
                                                                    ? aItem.specialPrice
                                                                    : aItem.cancellationPrice,
                                                                )}
                                                              </TableCell>

                                                              <TableCell align="right">
                                                                {this.props
                                                                  .providerType ===
                                                                  "SALES_CHNL_PROVIDER" ? (
                                                                  <>
                                                                    {currencyFormatter(
                                                                      (aItem.specialPrice
                                                                        ? aItem.specialPrice
                                                                        : aItem.cancellationPrice) *
                                                                      aItem.quantity *
                                                                      item
                                                                        .productOffering
                                                                        .quantity,
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  currencyFormatter(
                                                                    0,
                                                                    false,
                                                                  )
                                                                )}
                                                              </TableCell>
                                                              {/* <TableCell align='right'>{currencyFormatter(0)}</TableCell> */}
                                                            </TableRow>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </>
                                                      )}
                                                    {/* bom */}
                                                    {aItem.bom &&
                                                      aItem.bom.length > 0 && (
                                                        <TableContainer>
                                                          .
                                                          <Table className="newGlobalTable roundCorners">
                                                            <TableHead>
                                                              <TableRow>
                                                                <TableCell>
                                                                  <span>
                                                                    <IconButton
                                                                      onClick={
                                                                        this
                                                                          .handleExpandBom
                                                                      }
                                                                      style={{
                                                                        padding:
                                                                          "0px !important",
                                                                      }}
                                                                    >
                                                                      {this
                                                                        .state
                                                                        .expandBom ? (
                                                                        <>
                                                                          <KeyboardArrowUp fontSize="small" />
                                                                        </>
                                                                      ) : (
                                                                        <>
                                                                          <KeyboardArrowDown fontSize="small" />
                                                                        </>
                                                                      )}
                                                                    </IconButton>
                                                                    {this.state
                                                                      .expandBom
                                                                      ? t(
                                                                        "HIDE_BOM_ITEMS",
                                                                      )
                                                                      : t(
                                                                        "SHOW_BOM_ITEMS",
                                                                      )}
                                                                  </span>
                                                                </TableCell>
                                                              </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                              <TableRow>
                                                                <TableCell>
                                                                  <Collapse
                                                                    in={
                                                                      this.state
                                                                        .expandBom
                                                                    }
                                                                  >
                                                                    {aItem.bom
                                                                      .sort(
                                                                        (
                                                                          a,
                                                                          b,
                                                                        ) =>
                                                                          a && b
                                                                            ? a.displaySequence -
                                                                            b.displaySequence
                                                                            : 0,
                                                                      )
                                                                      .map(
                                                                        (
                                                                          bom,
                                                                          index,
                                                                        ) => (
                                                                          <React.Fragment
                                                                            key={
                                                                              bom.id
                                                                            }
                                                                          >
                                                                            <BomItemNew
                                                                              data={
                                                                                bom
                                                                              }
                                                                              index={
                                                                                index
                                                                              }
                                                                              parentItem={
                                                                                aItem
                                                                              }
                                                                              level={
                                                                                1
                                                                              }
                                                                              t={
                                                                                t
                                                                              }
                                                                            />
                                                                          </React.Fragment>
                                                                        ),
                                                                      )}
                                                                  </Collapse>
                                                                </TableCell>
                                                              </TableRow>
                                                            </TableBody>
                                                          </Table>
                                                        </TableContainer>
                                                      )}
                                                    {/* </div> */}
                                                    {aItem.expandChar && (
                                                      <TableRow>
                                                        <TableCell colSpan={4}>
                                                          <Collapse
                                                            in={
                                                              aItem.expandChar
                                                            }
                                                          >
                                                            <div
                                                              className={
                                                                classes.planDescription
                                                              }
                                                            />
                                                            <OfferingProductSpecCharacteristicsExistingDialog
                                                              t={t}
                                                              open={true}
                                                              productId={
                                                                aItem.id
                                                              }
                                                              offeringData={
                                                                item
                                                              }
                                                              productName={
                                                                aItem.name
                                                              }
                                                              onClose={
                                                                this
                                                                  .handleCloseSpecificationDialog
                                                              }
                                                              componentProductCharacteristics={
                                                                aItem.productSpec
                                                                  ? aItem.productSpec
                                                                  : {}
                                                              }
                                                              changedCharacteristics={
                                                                aItem.characteristics
                                                                  ? aItem.characteristics
                                                                  : []
                                                              }
                                                              onCharacteristicsChange={
                                                                this
                                                                  .handleCharacteristicsUpdate
                                                              }
                                                              screen="checkout"
                                                            />
                                                          </Collapse>
                                                        </TableCell>
                                                      </TableRow>
                                                    )}
                                                  </>
                                                ),
                                            )}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </div>
                                </Card>
                              </React.Fragment>
                            ))}
                        </Grid>
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 4,
                          }}
                        >
                          <Grid container spacing={1}>
                            {this.props.providerType !== "SOLUTION_PROVIDER" &&
                              this.props.permissions.includes(
                                "CUMULATOR_PROMO_ADMIN",
                              ) && (
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <Card
                                    variant="outlined"
                                    className={
                                      "roundCorners " + classes.totalsCard
                                    }
                                  >
                                    <b>{t("DISCOUNT_SUMMARY")}</b>
                                    {/* <span> % </span> */}
                                    <Grid container spacing={1}>
                                      <Grid
                                        item
                                        size={{
                                          xs: 12,
                                        }}
                                      >
                                        <Input
                                          // className={classes.quantityInput}
                                          type={"number"}
                                          min={0}
                                          step="1"
                                          name="discountPercentage"
                                          value={this.state.discountPercentage}
                                          onChange={(e) => {
                                            this.changePSDiscountValue(e);
                                          }}
                                          placeholder={t("DISCOUNT") + " %"}
                                          //onBlur={(e) => { this.tempChangePSDiscountVerify(e) }}
                                          style={{
                                            backgroundColor: "#fff",
                                            borderRadius: "5px",
                                            width: "100px",
                                          }}
                                          onKeyDown={(e) => {
                                            this.numbersOnly(e);
                                          }}
                                        />

                                        <div
                                          style={{
                                            alignContent: "end",
                                            display: "block",
                                          }}
                                        >
                                          <Button
                                            onClick={(e) => {
                                              this.changePSDiscount(e);
                                            }}
                                          >
                                            {t("APPLY_DISCOUNT")}
                                          </Button>
                                        </div>
                                      </Grid>
                                      {/* {this.state.cartData &&
                                                                            this.state.cartData.length > 0 &&
                                                                            this.state.cartData[0].cartTotalPrice &&
                                                                            this.state.cartData[0].cartTotalPrice.length > 0 && (
                                                                                <Grid item xs={12} justifyContent="space-between">
                                                                                    {t("DISCOUNT_APPLIED")} <b>{currencyFormatter(this.state.discount)}</b>
                                                                                </Grid>
                                                                            )} */}
                                      {this.state.cartData &&
                                        this.state.cartData.length > 0 &&
                                        this.state.cartData[0].totalDiscount &&
                                        this.state.cartData[0].totalDiscount
                                          .totalDepositDiscount && (
                                          <Grid
                                            item
                                            justifyContent="space-between"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {t("DUE_NOW")}{" "}
                                            <b>
                                              {currencyFormatter(
                                                this.state.cartData[0]
                                                  .totalDiscount
                                                  .totalDepositDiscount,
                                              )}
                                            </b>
                                          </Grid>
                                        )}
                                      {this.state.cartData &&
                                        this.state.cartData.length > 0 &&
                                        this.state.cartData[0].totalDiscount &&
                                        this.state.cartData[0].totalDiscount
                                          .totalOTCDiscount && (
                                          <Grid
                                            item
                                            justifyContent="space-between"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {t("DUE_AT_INSTALLATION")}{" "}
                                            <b>
                                              {currencyFormatter(
                                                this.state.cartData[0]
                                                  .totalDiscount
                                                  .totalOTCDiscount,
                                              )}
                                            </b>
                                          </Grid>
                                        )}
                                      {this.state.cartData &&
                                        this.state.cartData.length > 0 &&
                                        this.state.cartData[0].totalDiscount &&
                                        this.state.cartData[0].totalDiscount
                                          .totalRecurringDiscount && (
                                          <Grid
                                            item
                                            justifyContent="space-between"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {t("RECURRING_CHARGES")}{" "}
                                            <b>
                                              {currencyFormatter(
                                                this.state.cartData[0]
                                                  .totalDiscount
                                                  .totalRecurringDiscount,
                                              )}
                                            </b>
                                          </Grid>
                                        )}
                                      {this.state.cartData &&
                                        this.state.cartData.length > 0 &&
                                        this.state.cartData[0].totalDiscount &&
                                        this.state.cartData[0].totalDiscount
                                          .totalCancelDiscount && (
                                          <Grid
                                            item
                                            justifyContent="space-between"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {t("CANCELLATION_PRICE")}{" "}
                                            <b>
                                              {currencyFormatter(
                                                this.state.cartData[0]
                                                  .totalDiscount
                                                  .totalCancelDiscount,
                                              )}
                                            </b>
                                          </Grid>
                                        )}
                                      {this.state.cartData &&
                                        this.state.cartData.length > 0 &&
                                        this.state.cartData[0].totalDiscount &&
                                        this.state.cartData[0].totalDiscount
                                          .totalShiftDiscount && (
                                          <Grid
                                            item
                                            justifyContent="space-between"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {t("SHIFT_PRICE")}{" "}
                                            <b>
                                              {currencyFormatter(
                                                this.state.cartData[0]
                                                  .totalDiscount
                                                  .totalShiftDiscount,
                                              )}
                                            </b>
                                          </Grid>
                                        )}
                                      {this.state.cartData &&
                                        this.state.cartData.length > 0 &&
                                        this.state.cartData[0].totalDiscount &&
                                        this.state.cartData[0].totalDiscount
                                          .totalUsagesDiscount && (
                                          <Grid
                                            item
                                            justifyContent="space-between"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {t("USAGE_CHARGE")}{" "}
                                            <b>
                                              {currencyFormatter(
                                                this.state.cartData[0]
                                                  .totalDiscount
                                                  .totalUsagesDiscount,
                                              )}
                                            </b>
                                          </Grid>
                                        )}
                                    </Grid>
                                  </Card>
                                </Grid>
                              )}
                            {this.props.providerType !==
                              "SOLUTION_PROVIDER" && (
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <Card
                                    variant="outlined"
                                    className={
                                      "roundCorners " + classes.totalsCard
                                    }
                                  >
                                    <b>{t("TOTAL_SUMMARY")}</b>
                                    <Grid container spacing={1}>
                                      <Grid
                                        item
                                        justifyContent="space-between"
                                        size={{
                                          xs: 12,
                                        }}
                                      >
                                        {t("DUE_NOW")}{" "}
                                        <b>
                                          {this.state.cartData &&
                                            this.state.cartData.length > 0 &&
                                            this.state.cartData[0]
                                              .cartTotalPrice &&
                                            this.state.cartData[0].cartTotalPrice
                                              .length > 0 &&
                                            currencyFormatter(
                                              this.state.priceDueNow,
                                            )}
                                        </b>
                                      </Grid>
                                      <Grid
                                        item
                                        justifyContent="space-between"
                                        size={{
                                          xs: 12,
                                        }}
                                      >
                                        {t("DUE_AT_INSTALLATION")}{" "}
                                        <b>
                                          {this.state.cartData &&
                                            this.state.cartData.length > 0 &&
                                            this.state.cartData[0]
                                              .cartTotalPrice &&
                                            this.state.cartData[0].cartTotalPrice
                                              .length > 0 &&
                                            currencyFormatter(
                                              this.state.priceDueAtInstallation,
                                            )}
                                        </b>
                                      </Grid>
                                      {this.state.priceNTCtotal
                                        .slice()
                                        .sort((chargeA, chargeB) => {
                                          const termUOMOrder = [
                                            "TF_hr",
                                            "TF_day",
                                            "TF_wk",
                                            "TF_mon",
                                            "TF_yr",
                                          ];
                                          const indexA = termUOMOrder.indexOf(
                                            chargeA.tenureUom,
                                          );
                                          const indexB = termUOMOrder.indexOf(
                                            chargeB.tenureUom,
                                          );
                                          return indexA - indexB;
                                        })
                                        .map((charge, index) => {
                                          const {
                                            key,
                                            termPeriod,
                                            tenureUom,
                                            price,
                                          } = charge;
                                          const displayText =
                                            termPeriod > 1
                                              ? `${t("NTC_CHARGES")} (per ${this.getPriceTenureUOM(
                                                tenureUom,
                                              )} for ${termPeriod} ${this.getPriceTenureUOM(tenureUom)}s)`
                                              : `${t("NTC_CHARGES")} (per ${this.getPriceTenureUOM(
                                                tenureUom,
                                              )} for ${termPeriod} ${this.getPriceTenureUOM(tenureUom)})`;
                                          return (
                                            price > 0 && (
                                              <Grid
                                                item
                                                key={index}
                                                justifyContent="space-between"
                                                size={{
                                                  xs: 12,
                                                }}
                                              >
                                                <span>{displayText}</span>
                                                <b>{currencyFormatter(price)}</b>
                                              </Grid>
                                            )
                                          );
                                        })}
                                      {this.state.priceRecuringChargeTotal
                                        .slice()
                                        .sort((chargeA, chargeB) => {
                                          const termUOMOrder = [
                                            "TF_hr",
                                            "TF_day",
                                            "TF_wk",
                                            "TF_mon",
                                            "TF_yr",
                                          ];
                                          const indexA = termUOMOrder.indexOf(
                                            chargeA.tenureUom,
                                          );
                                          const indexB = termUOMOrder.indexOf(
                                            chargeB.tenureUom,
                                          );
                                          return indexA - indexB;
                                        })
                                        .map((charge, index) => {
                                          const {
                                            key,
                                            termPeriod,
                                            tenureUom,
                                            price,
                                          } = charge;
                                          const displayText =
                                            termPeriod > 1
                                              ? `${t("RECURRING_CHARGES")} (per ${termPeriod} ${this.getPriceTenureUOM(tenureUom)}s)`
                                              : `${t("RECURRING_CHARGES")} (per ${this.getPriceTenureUOM(tenureUom)})`;

                                          return (
                                            price > 0 && (
                                              <Grid
                                                item
                                                key={index}
                                                justifyContent="space-between"
                                                size={{
                                                  xs: 12,
                                                }}
                                              >
                                                <span>{displayText}</span>
                                                <b>{currencyFormatter(price)}</b>
                                              </Grid>
                                            )
                                          );
                                        })}
                                      {this.props.type ===
                                        "CancelSubscripiton" && (
                                          <>
                                            <Grid
                                              item
                                              justifyContent="space-between"
                                              size={{
                                                xs: 12,
                                              }}
                                            >
                                              {t("CANCELLATION_PRICE")}{" "}
                                              <b>
                                                {this.state.cartData &&
                                                  this.state.cartData.length > 0 &&
                                                  this.state.cartData[0]
                                                    .cartTotalPrice &&
                                                  this.state.cartData[0]
                                                    .cartTotalPrice.length > 0 &&
                                                  currencyFormatter(
                                                    this.state
                                                      .cancellationPriceTotal,
                                                  )}
                                              </b>
                                            </Grid>
                                          </>
                                        )}
                                    </Grid>
                                  </Card>
                                </Grid>
                              )}
                            {this.state.mode === "/quote" && (
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                }}
                              >
                                <Card
                                  variant="outlined"
                                  className={
                                    "roundCorners " + classes.totalsCard
                                  }
                                >
                                  <b>{t("NOTES")}</b>
                                  {this.state.cartData &&
                                    this.state.cartData.length > 0 &&
                                    this.state.cartData[0].quoteStatus !==
                                    "QUO_APPROVED" &&
                                    this.state.cartData[0].quoteStatus !==
                                    "QUO_ORDERED" && (
                                      <>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "1rem",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <Input
                                            error={!!this.state.error.note}
                                            helperText={!!this.state.error.note}
                                            size={"small"}
                                            name={"notes"}
                                            variant={"outlined"}
                                            // placeholder={this.props.t("NOTES")}
                                            //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                                            value={this.state.notes}
                                            onChange={this.changeNotes}
                                            //inputProps={{ rows: "5", cols: "10", disabled: true }}
                                            inputProps={{
                                              multiline: true,
                                              rows: 5,
                                              cols: 10,
                                              disabled: false,
                                            }}
                                          />
                                          <div
                                            style={{
                                              justifyContent: "flex-end",
                                            }}
                                          >
                                            <Button
                                              onClick={() => {
                                                this.confirmQuote(true);
                                              }}
                                            >
                                              {t("ADD_NOTE")}
                                            </Button>
                                          </div>
                                        </div>
                                        {this.state.mode === "/quote" &&
                                          // this.state.cartData &&
                                          // this.state.cartData.length > 0 &&
                                          // this.state.cartData[0].comments.length > 0 && (
                                          this.state.newestNotes.length > 0 && (
                                            <>
                                              {/* {this.state.cartData[0].comments.map((item) => ( */}
                                              {this.state.newestNotes.map(
                                                (item) => (
                                                  <Grid
                                                    item
                                                    className={
                                                      "roundCorners borderOutline " +
                                                      classes.cartItemContainer
                                                    }
                                                    style={{
                                                      marginBottom: ".5rem",
                                                      marginTop: ".5rem",
                                                    }}
                                                    size={{
                                                      xs: 12,
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        marginTop: 0,
                                                        display: "initial",
                                                        whiteSpace: "pre-line",
                                                      }}
                                                    >
                                                      {item.text.length >
                                                        150 ? (
                                                        <>
                                                          {item.text.substring(
                                                            0,
                                                            150,
                                                          ) + "..."}{" "}
                                                          <u
                                                            style={{
                                                              cursor: "pointer",
                                                              fontStyle:
                                                                "italic",
                                                            }}
                                                            onClick={() =>
                                                              this.showFullNote(
                                                                item,
                                                              )
                                                            }
                                                          >
                                                            {t("READ_MORE")}
                                                          </u>
                                                        </>
                                                      ) : (
                                                        item.text
                                                      )}
                                                    </div>
                                                    <div
                                                      style={{
                                                        fontStyle: "italic",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {item.addedBy} <br />
                                                      {formatDate(
                                                        item.dateTime,
                                                      )}
                                                    </div>
                                                  </Grid>
                                                ),
                                              )}
                                              {this.state.cartData &&
                                                this.state.cartData.length >
                                                0 &&
                                                this.state.cartData[0]
                                                  .comments &&
                                                this.state.cartData[0].comments
                                                  .length > 2 && (
                                                  <div
                                                    style={{
                                                      marginTop: "1rem",
                                                      justifyContent:
                                                        "flex-end",
                                                    }}
                                                  >
                                                    <Button
                                                      className="buttonSecondary"
                                                      onClick={
                                                        this.handleOpenAllNotes
                                                      }
                                                    >
                                                      {t("VIEW_ALL_NOTES")}
                                                    </Button>
                                                  </div>
                                                )}
                                            </>
                                          )}
                                      </>
                                    )}
                                </Card>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </>
                    ) : (
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        {/* <Card variant="outlined" className={"roundCorners " + classes.cartItemCard}> */}
                        <div
                          className={classes.noitem}
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {this.state.searching
                            ? t("SEARCHING")
                            : t("NO_ITEMS_AVAILABLE_TO_SHOW_ERROR")}
                        </div>
                        {/* </Card> */}
                      </Grid>
                    )
                  ) : this.state.cartData && this.state.cartData.length > 0 ? (
                    <></>
                  ) : (
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      {/* <Card variant="outlined" className={"roundCorners " + classes.cartItemCard}> */}
                      <div
                        className={classes.noitem}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {this.state.searching
                          ? t("SEARCHING")
                          : t("NO_ITEMS_AVAILABLE_TO_SHOW_ERROR")}
                      </div>
                      {/* </Card> */}
                    </Grid>
                  )}
                </Grid>
                {/* </div> */}

                {/* Dialog to show all notes */}
                <Dialog
                  open={this.state.allNotesOpen}
                  PaperComponent={this.draggableDialogPaper}
                  onClose={this.handleCloseAllNotes}
                  maxWidth="md"
                  fullWidth={true}
                // PaperProps={{
                //     className: jssClasses.resizablePaper
                // }}
                >
                  <DialogTitle
                    id="draggableDialogPaper"
                    style={{ cursor: "move" }}
                  >
                    <div style={{ display: "flex" }}>
                      <span style={{ display: "inline-flex", width: "95%" }}>
                        {t("ALL_NOTES")}
                      </span>
                      <Tooltip
                        title={t("CLOSE")}
                        id="show-all-notes-dialog"
                        style={{ cursor: "move" }}
                      >
                        <IconButton
                          onTouchStart={this.handleCloseAllNotes}
                          onClick={this.handleCloseAllNotes}
                          aria-label="close"
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </DialogTitle>
                  <DialogContent>
                    <Grid container spacing={1}>
                      {this.state.cartData &&
                        this.state.cartData.length > 0 &&
                        this.state.cartData[0].comments &&
                        this.state.cartData[0].comments.length > 0 ? (
                        <>
                          <Grid container spacing={1}>
                            {this.state.cartData[0].comments.map((item) => (
                              <Grid
                                item
                                className={
                                  "roundCorners borderOutline " +
                                  classes.cartItemContainer
                                }
                                style={{ marginBottom: ".5rem" }}
                                size={{
                                  xs: 12,
                                }}
                              >
                                <div
                                  style={{
                                    padding: "0rem 1rem",
                                    display: "initial",
                                    whiteSpace: "pre-line",
                                  }}
                                >
                                  {item.text.length > 150 ? (
                                    <>
                                      {item.text.substring(0, 150) + "..."}{" "}
                                      <u
                                        style={{
                                          cursor: "pointer",
                                          fontStyle: "italic",
                                        }}
                                        onClick={() => this.showFullNote(item)}
                                      >
                                        {t("READ_MORE")}
                                      </u>
                                    </>
                                  ) : (
                                    item.text
                                  )}
                                </div>
                                {/* <div style={{ fontStyle: "italic", fontWeight: "bold", padding: "0rem 1rem" }}>{item.author}</div> */}
                                <div
                                  style={{
                                    fontStyle: "italic",
                                    fontWeight: "bold",
                                    padding: "0rem 1rem",
                                  }}
                                >
                                  {item.author} <br />
                                  {item.dateTime &&
                                    formatDate(item.dateTime)}
                                </div>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      ) : (
                        this.props.status === "Order Fulfilled" && (
                          <>
                            <div style={{ marginTop: "1rem" }}>
                              {this.props.t("NO_DATA_AVAILABLE")}
                            </div>
                          </>
                        )
                      )}
                    </Grid>
                  </DialogContent>
                </Dialog>

                {/* New cart UI is only handled for pricesummaryview- the other view is using the old format*/}
                {!this.props.priceSummaryView && (
                  <div>
                    {this.state.cartData &&
                      this.state.cartData.length > 0 &&
                      this.state.cartData[0].cartItem &&
                      this.state.cartData[0].cartItem.length > 0 && (
                        <Card variant="outlined" className={"roundCorners"}>
                          <TableContainer>
                            <Table className={"newGlobalTable"}>
                              <TableHead>
                                <TableRow>
                                  <TableCell>{t("ITEM")}</TableCell>
                                  <TableCell align="center">
                                    {t("QUANTITY")}
                                  </TableCell>
                                  {(this.props.providerType ===
                                    "SALES_CHNL_PROVIDER" ||
                                    this.props.publicBrowsing) && (
                                      <>
                                        <TableCell align="right">
                                          <Tooltip title={t("TODAY_COST_TITLE")}>
                                            <span>{t("TODAY_COST")}</span>
                                          </Tooltip>
                                        </TableCell>
                                        <TableCell align="right">
                                          <Tooltip
                                            title={t("RECURRING_COST_TITLE")}
                                          >
                                            <span>{t("RECURRING_COST")}</span>
                                          </Tooltip>
                                        </TableCell>
                                      </>
                                    )}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.cartData.length > 0 &&
                                  this.state.cartData[0].cartItem
                                    .sort((a, b) => a.index - b.index)
                                    .map((item, i) => (
                                      <React.Fragment key={i}>
                                        {item.productOffering.sellable ? (
                                          <>
                                            <TableRow>
                                              <TableCell>
                                                <Button
                                                  className={
                                                    classes.removeButton
                                                  }
                                                  onClick={() => {
                                                    this.showRemoveItemWarning(
                                                      item,
                                                    );
                                                  }}
                                                  style={{
                                                    marginRight: "15px",
                                                    marginTop: "4px",
                                                  }}
                                                >
                                                  <span>x</span>
                                                </Button>
                                                <React.Fragment>
                                                  <Input
                                                    className={
                                                      classes.quantityInput
                                                    }
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    name="quantity"
                                                    value={
                                                      item.productOffering
                                                        .quantity
                                                    }
                                                    onChange={(e) => {
                                                      this.tempChangePSQuantity(
                                                        e,
                                                        item,
                                                      );
                                                    }}
                                                    onBlur={(e) => {
                                                      this.tempChangePSQuantityVerify(
                                                        e,
                                                        item,
                                                      );
                                                    }}
                                                    style={{
                                                      backgroundColor: "#fff",
                                                      borderRadius: "5px",
                                                    }}
                                                    onKeyDown={(e) => {
                                                      this.changePSQuantity(
                                                        e,
                                                        item,
                                                      );
                                                      if (e.keyCode === 69) {
                                                        e.preventDefault();
                                                      }
                                                    }}
                                                  />
                                                  <span> x </span>
                                                </React.Fragment>
                                                <b>
                                                  {item.productOffering.name}
                                                  {item.productOffering
                                                    .includedItems[0]
                                                    .productSpec &&
                                                    item.productOffering
                                                      .includedItems[0]
                                                      .productSpec.category && (
                                                      <Tooltip
                                                        title={t(
                                                          "PRODUCT_SPECIFICATION",
                                                        )}
                                                      >
                                                        <span
                                                          onClick={() =>
                                                            this.openProductSpecification(
                                                              item,
                                                              item
                                                                .productOffering
                                                                .includedItems[0],
                                                            )
                                                          }
                                                          style={{
                                                            display:
                                                              "inline-flex",
                                                            position:
                                                              "relative",
                                                            marginLeft: "10px",
                                                            top: "3px",
                                                          }}
                                                        >
                                                          <ClipboardWithGear />
                                                        </span>
                                                      </Tooltip>
                                                    )}
                                                </b>

                                                {/* {item.productOffering.specialPricing && item.productOffering.specialPricing.id &&
                                                                            <div className={classes.SolutionCountDiv} style={{ backgroundColor: 'transparent', padding: 0, border: 0, float: 'right' }}>
                                                                                {t('SPECIAL_PRICING')}: {item.productOffering.specialPricing.text}&nbsp;
                                                                                ({item.productOffering.specialPricing.type === 'PPC_OPEX' ? 'Opex Pricing - ' + item.productOffering.specialPricing.duration + ' Months' : this.props.t('CUSTOM_PRICING')})
                                                                            </div>
                                                                        } */}
                                              </TableCell>
                                              {item.productOffering.includedItems.map(
                                                (aItem, aIndex) => (
                                                  <>
                                                    {(this.props
                                                      .providerType ===
                                                      "SALES_CHNL_PROVIDER" ||
                                                      this.props
                                                        .publicBrowsing) && (
                                                        <>
                                                          <TableCell align="center">
                                                            {formatNumber(aItem.quantity *
                                                              item.productOffering
                                                                .quantity)}
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {aItem.priceType ===
                                                              "NR"
                                                              ? currencyFormatter(
                                                                (aItem.specialPrice
                                                                  ? aItem.specialPrice
                                                                  : aItem.price) *
                                                                aItem.quantity *
                                                                item
                                                                  .productOffering
                                                                  .quantity,
                                                              )
                                                              : currencyFormatter(
                                                                0,
                                                              )}
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {aItem.priceType ===
                                                              "RC"
                                                              ? currencyFormatter(
                                                                (aItem.specialPrice
                                                                  ? aItem.specialPrice
                                                                  : aItem.price) *
                                                                aItem.quantity *
                                                                item
                                                                  .productOffering
                                                                  .quantity,
                                                              )
                                                              : currencyFormatter(
                                                                0,
                                                              )}
                                                          </TableCell>
                                                        </>
                                                      )}
                                                  </>
                                                ),
                                              )}
                                            </TableRow>
                                            {item.productOffering
                                              .includedItems[0].bom &&
                                              item.productOffering
                                                .includedItems[0].bom.length >
                                              0 && (
                                                <TableRow>
                                                  <TableCell
                                                    colSpan={
                                                      this.props
                                                        .providerType ===
                                                        "SALES_CHNL_PROVIDER" ||
                                                        this.props.publicBrowsing
                                                        ? 4
                                                        : 1
                                                    }
                                                  >
                                                    <Collapse in={true}>
                                                      {item.productOffering.includedItems[0].bom
                                                        .sort((a, b) =>
                                                          a && b
                                                            ? a.displaySequence -
                                                            b.displaySequence
                                                            : 0,
                                                        )
                                                        .map((bom, index) => (
                                                          <div
                                                            key={bom.id}
                                                            style={{
                                                              marginLeft:
                                                                "93px",
                                                              marginRight:
                                                                "36px",
                                                            }}
                                                          >
                                                            <BomItem
                                                              data={bom}
                                                              index={index}
                                                              t={t}
                                                              parentItem={
                                                                item
                                                                  .productOffering
                                                                  .includedItems[0]
                                                              }
                                                              level={1}
                                                            />
                                                          </div>
                                                        ))}
                                                    </Collapse>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            {/* {item.productOffering.includedItems[0].bom && item.productOffering.includedItems[0].bom.length > 0 &&
                                                                        <TableRow>
                                                                            <TableCell ref={(el) => el && el.style.setProperty('color', '#ff0000')} style={{ padding: '10px 0px 0px 0px !important' }} colSpan={(this.props.providerType === 'SALES_CHNL_PROVIDER' || this.props.publicBrowsing) ? 3 : 1}>Swarn Singh</TableCell>
                                                                        </TableRow>
                                                                    } */}
                                          </>
                                        ) : (
                                          <TableRow>
                                            <TableCell
                                              colSpan={
                                                this.props.providerType ===
                                                  "SALES_CHNL_PROVIDER"
                                                  ? 4
                                                  : 2
                                              }
                                            >
                                              {/* <Button className={classes.removeButton} onClick={() => { this.showRemoveItemWarning(item) }} style={{ marginRight: '15px', marginTop: '4px' }}><span>x</span></Button>
                                                                            <React.Fragment>
                                                                                <Input
                                                                                    className={classes.quantityInput}
                                                                                    type="number"
                                                                                    min="1"
                                                                                    step="1"
                                                                                    name="quantity"
                                                                                    value={item.productOffering.quantity}
                                                                                    onChange={(e) => { this.tempChangePSQuantity(e, item) }}
                                                                                    onBlur={(e) => { this.tempChangePSQuantityVerify(e, item) }}
                                                                                    style={{ backgroundColor: '#fff', borderRadius: '5px' }}
                                                                                    onKeyDown={(e) => { this.changePSQuantity(e, item) }}
                                                                                />
                                                                                <span> x </span>
                                                                            </React.Fragment> */}
                                              {this.state.cartData[0]
                                                .quoteStatus !== "QUO_REVIEW" &&
                                                this.state.cartData[0]
                                                  .quoteStatus !==
                                                "QUO_APPROVED" &&
                                                this.state.cartData[0]
                                                  .quoteStatus !==
                                                "QUO_ORDERED" &&
                                                this.state.cartData[0]
                                                  .quoteStatus !==
                                                "QUO_WAIT_ORDER" ? (
                                                <>
                                                  <Button
                                                    className={
                                                      classes.removeButton
                                                    }
                                                    onClick={() => {
                                                      this.showRemoveItemWarning(
                                                        item,
                                                      );
                                                    }}
                                                    style={{
                                                      marginRight: "15px",
                                                      marginTop: "4px",
                                                    }}
                                                  >
                                                    <span>x</span>
                                                  </Button>
                                                  <React.Fragment>
                                                    <Input
                                                      className={
                                                        classes.quantityInput
                                                      }
                                                      type="number"
                                                      min="1"
                                                      step="1"
                                                      name="quantity"
                                                      value={
                                                        item.productOffering
                                                          .quantity
                                                      }
                                                      onChange={(e) => {
                                                        this.tempChangePSQuantity(
                                                          e,
                                                          item,
                                                        );
                                                      }}
                                                      onBlur={(e) => {
                                                        this.tempChangePSQuantityVerify(
                                                          e,
                                                          item,
                                                        );
                                                      }}
                                                      style={{
                                                        backgroundColor: "#fff",
                                                        borderRadius: "5px",
                                                      }}
                                                      onKeyDown={(e) => {
                                                        this.changePSQuantity(
                                                          e,
                                                          item,
                                                        );
                                                        if (e.keyCode === 69) {
                                                          e.preventDefault();
                                                        }
                                                      }}
                                                    />
                                                    <span> x </span>
                                                  </React.Fragment>
                                                </>
                                              ) : (
                                                <React.Fragment>
                                                  <Input
                                                    className={
                                                      classes.quantityInput
                                                    }
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    name="quantity"
                                                    value={
                                                      item.productOffering
                                                        .quantity
                                                    }
                                                    onChange={(e) => {
                                                      this.tempChangePSQuantity(
                                                        e,
                                                        item,
                                                      );
                                                    }}
                                                    onBlur={(e) => {
                                                      this.tempChangePSQuantityVerify(
                                                        e,
                                                        item,
                                                      );
                                                    }}
                                                    style={{
                                                      backgroundColor: "#fff",
                                                      borderRadius: "5px",
                                                    }}
                                                    onKeyDown={(e) => {
                                                      this.changePSQuantity(
                                                        e,
                                                        item,
                                                      );
                                                      if (e.keyCode === 69) {
                                                        e.preventDefault();
                                                      }
                                                    }}
                                                    disabled={true}
                                                  />
                                                  <span> x </span>
                                                </React.Fragment>
                                              )}
                                              <b>{item.productOffering.name}</b>

                                              {item.productOffering
                                                .specialPricing &&
                                                item.productOffering
                                                  .specialPricing.id && (
                                                  <>
                                                    {item.productOffering
                                                      .specialPricing.type &&
                                                      item.productOffering
                                                        .specialPricing.type ===
                                                      "VOLUME_PRICING" ? (
                                                      ""
                                                    ) : (
                                                      <div
                                                        className={
                                                          classes.SolutionCountDiv
                                                        }
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          padding: 0,
                                                          border: 0,
                                                          float: "right",
                                                        }}
                                                      >
                                                        {t("SPECIAL_PRICING")}:{" "}
                                                        {
                                                          item.productOffering
                                                            .specialPricing.text
                                                        }
                                                        &nbsp; (
                                                        {item.productOffering
                                                          .specialPricing
                                                          .type === "PPC_OPEX"
                                                          ? "Opex Pricing - " +
                                                          item.productOffering
                                                            .specialPricing
                                                            .duration +
                                                          " Months"
                                                          : this.props.t(
                                                            "CUSTOM_PRICING",
                                                          )}
                                                        )
                                                      </div>
                                                    )}
                                                  </>
                                                )}
                                            </TableCell>
                                          </TableRow>
                                        )}
                                        {!item.productOffering.sellable &&
                                          item.productOffering.includedItems.map(
                                            (aItem, aIndex) =>
                                              this.checkFulfillable(
                                                aItem.fulfillable,
                                              ) &&
                                              aItem.customerViewable && (
                                                <>
                                                  <TableRow
                                                    key={aIndex}
                                                    className="associatedItems-wrapperDiv"
                                                  >
                                                    <TableCell>
                                                      <span
                                                        style={{
                                                          display: "block",
                                                          paddingLeft: "103px",
                                                        }}
                                                        title={
                                                          aItem.description
                                                            ? aItem.description
                                                            : ""
                                                        }
                                                      >
                                                        {aItem.name}&nbsp;
                                                        {/* <span title={t('QUANTITY_X_PRICE')}>
                                                                                        {(this.props.providerType === 'SALES_CHNL_PROVIDER' || this.props.publicBrowsing) ?
                                                                                            <>
                                                                                                ({aItem.quantity * item.productOffering.quantity} x {currencyFormatter(aItem.specialPrice ? aItem.specialPrice : aItem.price)})
                                                                                            </>
                                                                                            :
                                                                                            <>({aItem.quantity * item.productOffering.quantity})</>
                                                                                        }
                                                                                    </span> */}
                                                      </span>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      <span
                                                        title={t("QUANTITY")}
                                                      >
                                                        <>
                                                          {formatNumber(aItem.quantity *
                                                            item.productOffering
                                                              .quantity)}
                                                        </>
                                                      </span>
                                                    </TableCell>
                                                    {(this.props
                                                      .providerType ===
                                                      "SALES_CHNL_PROVIDER" ||
                                                      this.props
                                                        .publicBrowsing) && (
                                                        <>
                                                          <TableCell align="right">
                                                            {aItem.priceType ===
                                                              "NR" ||
                                                              aItem.priceType ===
                                                              "NTC"
                                                              ? currencyFormatter(
                                                                (aItem.specialPrice
                                                                  ? aItem.specialPrice
                                                                  : aItem.price) *
                                                                aItem.quantity *
                                                                item
                                                                  .productOffering
                                                                  .quantity,
                                                              )
                                                              : currencyFormatter(
                                                                0,
                                                              )}
                                                          </TableCell>
                                                          <TableCell align="right">
                                                            {aItem.priceType ===
                                                              "RC"
                                                              ? currencyFormatter(
                                                                (aItem.specialPrice
                                                                  ? aItem.specialPrice
                                                                  : aItem.price) *
                                                                aItem.quantity *
                                                                item
                                                                  .productOffering
                                                                  .quantity,
                                                              )
                                                              : currencyFormatter(
                                                                0,
                                                              )}
                                                          </TableCell>
                                                        </>
                                                      )}
                                                  </TableRow>
                                                  {aItem.bom &&
                                                    aItem.bom.length > 0 && (
                                                      <TableRow>
                                                        <TableCell
                                                          colSpan={
                                                            this.props
                                                              .providerType ===
                                                              "SALES_CHNL_PROVIDER" ||
                                                              this.props
                                                                .publicBrowsing
                                                              ? 4
                                                              : 1
                                                          }
                                                        >
                                                          <Collapse in={true}>
                                                            {aItem.bom
                                                              .sort((a, b) =>
                                                                a && b
                                                                  ? a.displaySequence -
                                                                  b.displaySequence
                                                                  : 0,
                                                              )
                                                              .map(
                                                                (
                                                                  bom,
                                                                  index,
                                                                ) => (
                                                                  <div
                                                                    key={bom.id}
                                                                    style={{
                                                                      marginLeft:
                                                                        "153px",
                                                                      marginRight:
                                                                        "36px",
                                                                    }}
                                                                  >
                                                                    <BomItem
                                                                      data={bom}
                                                                      index={
                                                                        index
                                                                      }
                                                                      parentItem={
                                                                        aItem
                                                                      }
                                                                      level={1}
                                                                      t={t}
                                                                    />
                                                                  </div>
                                                                ),
                                                              )}
                                                          </Collapse>
                                                        </TableCell>
                                                      </TableRow>
                                                    )}
                                                </>
                                              ),
                                          )}
                                        {!item.productOffering.sellable &&
                                          item.discountDetails &&
                                          item.discountDetails.value &&
                                          (this.props.providerType ===
                                            "SALES_CHNL_PROVIDER" ||
                                            this.props.publicBrowsing) && (
                                            <TableRow className="associatedItems-wrapperDiv">
                                              <TableCell>
                                                <span
                                                  style={{
                                                    display: "block",
                                                    paddingLeft: "103px",
                                                    fontWeight: "bold",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {item.discountDetails.value}%{" "}
                                                  {t("DISCOUNT")}
                                                </span>
                                              </TableCell>
                                              <TableCell align="right">
                                                -{" "}
                                                {currencyFormatter(
                                                  item.discountDetails
                                                    .nrDiscount,
                                                )}
                                                {/* {(aItem.priceType === 'NR') ? currencyFormatter(((aItem.specialPrice ? aItem.specialPrice : aItem.price) * aItem.quantity) * item.productOffering.quantity) : currencyFormatter(0)} */}
                                              </TableCell>
                                              <TableCell align="right">
                                                -{" "}
                                                {currencyFormatter(
                                                  item.discountDetails
                                                    .rcDiscount,
                                                )}
                                                {/* {(aItem.priceType === 'RC') ? currencyFormatter(((aItem.specialPrice ? aItem.specialPrice : aItem.price) * aItem.quantity) * item.productOffering.quantity) : currencyFormatter(0)} */}
                                              </TableCell>
                                            </TableRow>
                                          )}
                                      </React.Fragment>
                                    ))}
                                {(this.props.providerType ===
                                  "SALES_CHNL_PROVIDER" ||
                                  this.props.publicBrowsing) && (
                                    <TableRow>
                                      <TableCell>
                                        <b>{t("TOTAL")}</b>
                                      </TableCell>
                                      <TableCell align="right"></TableCell>
                                      <TableCell align="right">
                                        <b>
                                          {this.state.cartData &&
                                            this.state.cartData.length > 0 &&
                                            this.state.cartData[0]
                                              .cartTotalPrice &&
                                            this.state.cartData[0].cartTotalPrice
                                              .length > 0 &&
                                            this.state.cartData[0].cartTotalPrice.map(
                                              (price) =>
                                                price.priceType === "NR" &&
                                                currencyFormatter(price.price),
                                            )}
                                        </b>
                                      </TableCell>
                                      <TableCell align="right">
                                        <b>
                                          {this.state.cartData &&
                                            this.state.cartData.length > 0 &&
                                            this.state.cartData[0]
                                              .cartTotalPrice &&
                                            this.state.cartData[0].cartTotalPrice
                                              .length > 0 &&
                                            this.state.cartData[0].cartTotalPrice.map(
                                              (price) =>
                                                price.priceType === "RC" &&
                                                currencyFormatter(price.price),
                                            )}
                                        </b>
                                      </TableCell>
                                    </TableRow>
                                  )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Card>
                      )}
                    {this.state.cartData &&
                      this.state.cartData.length === 0 && (
                        <div className={classes.noitem}>
                          {/* {(this.props.solutionList.length === 0) && (this.props.accessoryList.length === 0) ?
                                                    t('NO_ITEMS_AVAILABLE_TO_SHOW_ERROR')
                                                    :
                                                    null
                                                } */}
                          {this.state.searching
                            ? t("SEARCHING")
                            : t("NO_ITEMS_AVAILABLE_TO_SHOW_ERROR")}
                        </div>
                      )}
                  </div>
                )}
                {this.state.cartData &&
                  this.state.cartData.length > 0 &&
                  this.state.cartData[0].quoteStatus !== "QUO_REVIEW" &&
                  this.state.cartData[0].quoteStatus !== "QUO_APPROVED" &&
                  this.state.cartData[0].quoteStatus !== "QUO_ORDERED" &&
                  this.state.cartData[0].quoteStatus !== "QUO_WAIT_ORDER" && (
                    <div style={{ marginTop: "25px" }}>
                      {this.props.priceSummaryView ? (
                        <Grid container spacing={1}>
                          <Grid
                            item
                            align="right"
                            size={{
                              xs: 12,
                              md: 8,
                            }}
                          >
                            <Button
                              onClick={() => {
                                this.addOfferings();
                              }}
                            >
                              <span
                                style={{
                                  verticalAlign: "middle",
                                  marginRight: ".25rem",
                                }}
                              >
                                <PlusIcon />
                              </span>
                              {t("ADD_OFFERINGS")}
                            </Button>
                            <Button
                              onClick={() => {
                                this.updateQuoteData();
                              }}
                              disabled={!this.state.unsavedChanges}
                              style={{ marginLeft: "15px", marginRight: "4px" }}
                            >
                              {/* <span style={{ verticalAlign: "middle", marginRight: ".25rem" }}>
                                                            <PlusIcon />
                                                        </span> */}
                              {this.state.mode === "/quote"
                                ? t("UPDATE_QUOTE")
                                : t("UPDATE_CART")}
                            </Button>
                          </Grid>
                        </Grid>
                      ) : (
                        <>
                          <Button
                            onClick={() => {
                              this.addOfferings();
                            }}
                          >
                            <span
                              style={{
                                verticalAlign: "middle",
                                marginRight: ".25rem",
                              }}
                            >
                              <PlusIcon />
                            </span>
                            {t("ADD_OFFERINGS")}
                          </Button>
                          <Button
                            onClick={() => {
                              this.updateQuoteData();
                            }}
                            disabled={!this.state.unsavedChanges}
                            style={{ marginLeft: "15px", marginRight: "4px" }}
                          >
                            {/* <span style={{ verticalAlign: "middle", marginRight: ".25rem" }}>
                                                            <PlusIcon />
                                                        </span> */}
                            {this.state.mode === "/quote"
                              ? t("UPDATE_QUOTE")
                              : t("UPDATE_CART")}
                          </Button>
                        </>
                      )}
                    </div>
                  )}

                {this.state.cartData &&
                  this.state.cartData.length > 0 &&
                  this.state.quoteHistory &&
                  this.state.quoteHistory.length > 0 && (
                    <div style={{ margin: "25px 0" }}>
                      <h3 style={{ color: "#000" }}>
                        {this.props.t("QUOTE_STATUS_HISTORY")}
                        <Tooltip title={this.props.t("REFRESH_QUOTE_HISTORY")}>
                          <IconButton
                            onClick={() => {
                              this.setState({ loading: true });
                              this.state.unsavedChanges
                                ? this.updateQuoteData()
                                : this.getQuoteData();
                            }}
                            style={{ float: "right" }}
                            className="iconButtonSecondary"
                          >
                            <RefreshIcon />
                          </IconButton>
                        </Tooltip>
                      </h3>
                      <Card variant="outlined" className={"roundCorners"}>
                        <TableContainer>
                          <Table className={"newGlobalTable"}>
                            <TableHead>
                              <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                  {this.props.t("DATE")}
                                </TableCell>
                                <TableCell style={{ width: "30%" }}>
                                  {this.props.t("STATUS_CHANGE")}
                                </TableCell>
                                <TableCell style={{ width: "50%" }}>
                                  {this.props.t("ADDITIONAL_INFO")}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.is_order_status && (
                                <TableRow>
                                  <TableCell>
                                    {formatDate(
                                      this.state.order_status_details
                                        .statusChangeTime,
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    <u
                                      onClick={() => {
                                        this.showActionDialog();
                                      }}
                                      style={{ cursor: "pointer" }}
                                      className="button"
                                    >
                                      {
                                        this.state.order_status_details
                                          .status_text
                                      }
                                    </u>
                                  </TableCell>
                                  <TableCell>
                                    {this.state.order_status_details
                                      .status_description &&
                                      this.state.order_status_details.status_description
                                        .split("\n")
                                        .map((item, index) => (
                                          <React.Fragment key={index}>
                                            {item}
                                            <br />
                                          </React.Fragment>
                                        ))}
                                  </TableCell>
                                </TableRow>
                              )}
                              {this.state.quoteHistory.map((item, index) => (
                                <>
                                  <TableRow key={index}>
                                    <TableCell>
                                      {formatDate(
                                        item.statusDatetime,
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {index === 0 &&
                                        this.state.formFields &&
                                        this.state.formFields.fields &&
                                        this.state.formFields.fields.length > 0 &&
                                        this.state.isEligibleUser ? (
                                        <u
                                          onClick={() => {
                                            this.showActionDialog();
                                          }}
                                          style={{ cursor: "pointer" }}
                                          className="button"
                                        >
                                          {item.quoteStatus}
                                        </u>
                                      ) : (
                                        item.quoteStatus
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {/* {index === 0 ?
                                                                        <>
                                                                            {this.state.eligibleRole ?
                                                                                <>
                                                                                    {this.state.eligibleRole ? 'Waiting for ' + this.state.eligibleRole + ' action' : ''}
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {item.changeReason &&
                                                                                        item.changeReason.split('\\n').map((item, index) => (
                                                                                            <React.Fragment key={index}>
                                                                                                {item}
                                                                                                <br />
                                                                                            </React.Fragment>
                                                                                        ))}
                                                                                </>
                                                                            }
                                                                        </>
                                                                        :
                                                                        <>
                                                                            {item.changeReason &&
                                                                                item.changeReason.split('\\n').map((item, index) => (
                                                                                    <React.Fragment key={index}>
                                                                                        {item}
                                                                                        <br />
                                                                                    </React.Fragment>
                                                                                ))}
                                                                        </>
                                                                    } */}
                                      {item.changeReason && (
                                        <React.Fragment key={index}>
                                          {item.changeReason.includes("<a ") ? (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: item.changeReason,
                                              }}
                                            />
                                          ) : (
                                            <>
                                              {item.changeReason
                                                .split("\\n")
                                                .map((item, index) => (
                                                  <React.Fragment key={index}>
                                                    {item}
                                                    <br />
                                                  </React.Fragment>
                                                ))}
                                            </>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                </>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </div>
                  )}

                <div>
                  {this.state.mode === "/quote" &&
                    !this.props.priceSummaryView &&
                    this.state.cartData &&
                    this.state.cartData.length > 0 &&
                    this.state.cartData[0].comments &&
                    this.state.cartData[0].comments.length > 0 && (
                      <div style={{ margin: "25px 0" }}>
                        <h3 style={{ color: "#000" }}>
                          {this.props.t("NOTES")}
                        </h3>
                        <Card variant="outlined" className={"roundCorners"}>
                          <TableContainer>
                            <Table className={"newGlobalTable"}>
                              <TableHead>
                                <TableRow>
                                  <TableCell>{t("DATE")}</TableCell>
                                  <TableCell>{t("COMMENT")}</TableCell>
                                  <TableCell>{t("BY")}</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.cartData[0].comments.map(
                                  (comment) => (
                                    <TableRow>
                                      <TableCell>
                                        {formatDate(
                                          comment.dateTime,
                                        )}
                                      </TableCell>
                                      <TableCell>{comment.text}</TableCell>
                                      <TableCell>{comment.addedBy}</TableCell>
                                    </TableRow>
                                  ),
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Card>
                      </div>
                    )}
                  {this.state.mode === "/quote" && (
                    <>
                      {/* {(this.props.loggedInUserType === "SALES_MANAGER" || this.props.permissions.includes("CUMULATOR-QUOTE_UPDATE")) ?
                                                <>
                                                    {this.state.cartData && this.state.cartData.length > 0 && this.state.cartData[0].quoteStatus === 'QUO_REVIEW' &&
                                                        <div>
                                                            <div style={{ margin: '25px 0' }}>
                                                                <Input
                                                                    size={'small'}
                                                                    name={'notes'}
                                                                    variant={'outlined'}
                                                                    placeholder={this.props.t('NOTES') + '.......'}
                                                                    //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                                                                    value={this.state.notes}
                                                                    onChange={this.changeNotes}
                                                                    //inputProps={{ rows: "5", cols: "10", disabled: true }}
                                                                    inputProps={{ rows: 5, cols: 10, disabled: false }}
                                                                    multiline={true}
                                                                />
                                                            </div>
                                                            <div align="right" style={{ margin: '25px 0' }}>
                                                                <Button onClick={() => { this.verifyQuote('QUO_REJECTED') }} style={{ marginRight: '15px' }}>{this.props.t('REJECT')}</Button>
                                                                <Button onClick={() => { this.verifyQuote('QUO_APPROVED') }}>{this.props.t('APPROVE')}</Button>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.cartData && this.state.cartData.length > 0 && this.state.cartData[0].quoteStatus === 'QUO_APPROVED' &&
                                                        <>
                                                            <div style={{ margin: '25px 0' }}>
                                                                <div>
                                                                    <Input
                                                                        size={'small'}
                                                                        name={'notes'}
                                                                        variant={'outlined'}
                                                                        placeholder={this.props.t('NOTES') + '.......'}
                                                                        //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                                                                        value={this.state.notes}
                                                                        onChange={this.changeNotes}
                                                                        //inputProps={{ rows: "5", cols: "10", disabled: true }}
                                                                        inputProps={{ multiline: true, rows: 5, cols: 10, disabled: false }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div align="right" style={{ margin: '25px 0' }}>
                                                                <Button onClick={() => { this.verifyQuote('QUO_REJECTED') }} style={{ marginRight: '15px' }}>{this.props.t('REJECT')}</Button>
                                                                <Button onClick={() => { this.createOrder() }}>{t('CREATE_ORDER')}</Button>
                                                            </div>
                                                        </>
                                                    }
                                                </>
                                                :
                                                ''
                                            } */}
                      {!this.props.priceSummaryView &&
                        this.state.cartData &&
                        this.state.cartData.length > 0 &&
                        this.state.cartData[0].quoteStatus !== "QUO_APPROVED" &&
                        this.state.cartData[0].quoteStatus !==
                        "QUO_ORDERED" && (
                          <>
                            <div style={{ margin: "25px 0" }}>
                              <div>
                                <Input
                                  size={"small"}
                                  name={"notes"}
                                  variant={"outlined"}
                                  placeholder={
                                    this.props.t("NOTES") + "......."
                                  }
                                  //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                                  value={this.state.notes}
                                  onChange={this.changeNotes}
                                  //inputProps={{ rows: "5", cols: "10", disabled: true }}
                                  inputProps={{
                                    multiline: true,
                                    rows: 5,
                                    cols: 10,
                                    disabled: false,
                                  }}
                                />
                              </div>
                            </div>
                            <div align="right" style={{ margin: "25px 0" }}>
                              {this.state.cartData &&
                                this.state.cartData.length > 0 &&
                                this.state.cartData[0].quoteStatus !==
                                "QUO_REVIEW" &&
                                this.state.cartData[0].quoteStatus !==
                                "QUO_APPROVED" &&
                                this.state.cartData[0].quoteStatus !==
                                "QUO_ORDERED" &&
                                this.state.cartData[0].quoteStatus !==
                                "QUO_WAIT_ORDER" && (
                                  <Button
                                    onClick={() => {
                                      this.props.setErrorMessage("");
                                      this.props.clearCart();
                                      this.showClearCartWarning();
                                      this.props.setPromoBan("");
                                    }}
                                    className={classes.clearCartButton}
                                    disabled={this.state.disableCheckout}
                                    style={{ marginRight: "15px" }}
                                  >
                                    {t("CANCEL_QUOTE")}
                                  </Button>
                                )}
                              <Button
                                onClick={() => {
                                  this.confirmQuote(true);
                                }}
                              >
                                {t("ADD_NOTE")}
                              </Button>
                            </div>
                          </>
                        )}
                    </>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>

          {/* Change customer */}
          {this.state.showSelectCustomer && (
            <Dialog
              disableScrollLock={true}
              maxWidth={"lg"}
              fullWidth={true}
              open={this.state.showSelectCustomer}
              PaperComponent={this.draggableDialogPaper}
            // PaperProps={{
            //     className: jssClasses.resizablePaper
            // }}
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                {this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                  this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                  ? t("SELECT_SHIPPING_ADDRESS")
                  : t("SELECT_CUSTOMER")}
              </DialogTitle>
              <DialogContent dividers style={{ height: "550px" }}>
                <ManageCustomersHierarchy
                  screen="checkout"
                  subScreen="product"
                  stage={this.state.stage}
                  next={this.selectCustomerClose}
                  // back={this.back}
                  selectedTreeItems={this.state.selectedTreeItems}
                  customerDetails={this.state.customerDetails}
                  selectedPaymentMethod={this.state.selectedPaymentMethod}
                  resetSelecteddata={this.resetSelecteddata}
                  closeDialog={this.closeDialog}
                  setSelectCallback={this.setSelectCustomerCallback}
                />
              </DialogContent>
              <DialogActions>
                <Button className='buttonSecondary' onClick={this.closeDialog}>{t("CANCEL")}</Button>
                <Button onClick={() => this.onSelectCustomerCallback && this.onSelectCustomerCallback()}>{t("SELECT")}</Button>
              </DialogActions>
            </Dialog>
          )}

          <Loader loading={this.state.loading} />

          <Dialog
            maxWidth={"sm"}
            PaperComponent={this.draggableDialogPaper}
            fullWidth={true}
            open={this.state.removeItemWrning}
            aria-labelledby="delete-dialog-title"
            disableScrollLock={true}
          // PaperProps={{
          //     className: jssClasses.resizablePaper
          // }}
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {t("REMOVE")}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={() => this.removePSFromCart(false)}
                    onClick={() => this.removePSFromCart(false)}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                {t("REMOVE_ITEM_CONFIRMATION")}
                {this.state.itemToRemove.productOffering
                  ? this.state.itemToRemove.productOffering.name + "?"
                  : "?"}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(event) => this.removePSFromCart(false)}
                color="primary"
              >
                {t("NO")}
              </Button>
              <Button
                onClick={(event) => this.removePSFromCart(true)}
                color="primary"
              >
                {t("YES")}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            disableScrollLock={true}
            maxWidth={"sm"}
            PaperComponent={this.draggableDialogPaper}
            fullWidth={true}
            open={this.state.showClearWarning}
            aria-labelledby="delete-dialog-title"
          // PaperProps={{
          //     className: jssClasses.resizablePaper
          // }}
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {t(
                    this.state.mode === "/cart" ? "CLEAR_CART" : "CANCEL_QUOTE",
                  )}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={() => this.clearCustomerCart(false)}
                    onClick={() => this.clearCustomerCart(false)}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                {t(
                  this.state.mode === "/cart"
                    ? "CLEAR_CART_CONFIRMATION"
                    : "CANCEL_QUOTE_CONFIRMATION",
                  { customerData },
                )}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(event) => this.clearCustomerCart(false)}
                color="primary"
              >
                {t("NO")}
              </Button>
              <Button
                onClick={(event) => this.clearCustomerCart(true)}
                color="primary"
              >
                {t("YES")}
              </Button>
            </DialogActions>
          </Dialog>
          {this.state.formFields &&
            this.state.formFields.fields &&
            this.state.formFields.fields.length > 0 &&
            this.state.actionDialog && (
              <OrderActionDialog
                data={this.state.formFields}
                open={this.state.actionDialog}
                close={this.closeActionDialog}
                bpmnProcessInstanceId={this.state.bpmnProcessInstanceId}
              />
            )}

          {this.state.showBanDialog && (
            <Dialog
              maxWidth={"md"}
              PaperComponent={this.draggableDialogPaper}
              fullWidth={true}
              open={this.state.showBanDialog}
              disableScrollLock={true}
              aria-labelledby="delete-dialog-title"
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {this.state.cartData[0].customer.accountName}{" "}
                    {t("BAN_REQUIRED")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onClick={() => this.closeBanDialog()}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                <Input
                  size={"small"}
                  name={"custCodeValue"}
                  variant={"outlined"}
                  placeholder={this.props.t("CUSTOMER_BAN") + " *"}
                  value={this.state.custCodeValue}
                  onChange={this.changeCustomerBan}
                  helperText={
                    this.props.t("CUSTOMER_CODE_PREFIX_ERROR") +
                    " " +
                    this.state.cartData[0].customer.tempCustCodePrefix
                  }
                />
              </DialogContent>
              <DialogActions>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      float: "left",
                      fontWeight: "bold",
                      color: "#f44336",
                    }}
                  >
                    {this.state.showCustomerBanError &&
                      this.props.t("CUSTOMER_CODE_PREFIX_ERROR") +
                      " " +
                      this.state.cartData[0].customer.tempCustCodePrefix}
                  </div>
                  <div style={{ float: "right" }}>
                    <Button
                      onClick={(event) => this.createCustomerBan()}
                      color="primary"
                    >
                      {t("SUBMIT")}
                    </Button>
                  </div>
                  <div style={{ clear: "both" }}></div>
                </div>
              </DialogActions>
            </Dialog>
          )}
          {this.state.showNote && (
            <ShowNoteDialog
              note={this.state.noteData}
              open={this.state.showNote}
              close={this.closeFullNote}
            />
          )}
          {/* {this.state.showProductSpecification &&
                        <>
                            <OfferingProductSpecCharacteristicsExistingDialog t={t} open={this.state.showProductSpecification} productId={this.state.selectedProductSpecification.id} productName={this.state.selectedProductSpecification.name} onClose={this.handleCloseSpecificationDialog} componentProductCharacteristics={this.state.selectedProductSpecification.productSpec ? this.state.selectedProductSpecification.productSpec : {}} onCharacteristicsChange={this.handleCharacteristicsUpdate} changedCharacteristics={this.state.selectedCharacteristics || []} screen='checkout' />
                        </>
                    } */}
        </main>
      </div>
    );
  }
}

const BomItemNew = (bom) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: `${(bom.level - 1) * 4}rem`,
          flexDirection: "row",
        }}
      >
        <EnterArrow />
        <div>
          <b> {bom.data.name}</b>
          {bom.t("QUANTITY")}: (
          {bom.data.presetQuantity
            ? formatNumber(bom.data.presetQuantity * bom.parentItem.quantity)
            : formatNumber(1 * bom.parentItem.quantity)}
          )
        </div>
      </div>
      {bom.data.bom &&
        bom.data.bom.length > 0 &&
        bom.data.bom
          .sort((a, b) => (a && b ? a.displaySequence - b.displaySequence : 0))
          .map((child) => (
            <BomItemNew
              data={child}
              parentItem={bom.parentItem}
              level={bom.level + 1}
              t={bom.t}
            />
          ))}
    </div>
  );
};

const BomItem = (bom) => {
  return (
    bom.data.customerViewable && (
      <div
        style={{
          padding: "5px 25px 0",
          paddingTop: bom.index === 0 ? 0 : "5px",
          paddingLeft: bom.level === 1 ? 0 : "60px",
        }}
      >
        <TableContainer>
          <Table style={{ width: "100%" }} className="noPaddingTd">
            <TableBody>
              <TableRow>
                <TableCell style={{ paddingRight: 0 }}>
                  {/* <div style={{ width: '60px', float: 'left' }}>
                            <Input
                                className={classes.quantityInput}
                                value={bom.data.presetQuantity ? bom.data.presetQuantity * bom.parentItem.quantity : 1 * bom.parentItem.quantity}
                                disabled={true}
                            />
                        </div> */}
                  <div
                    style={{
                      width: "calc(100% - 60px)",
                      float: "left",
                      lineHeight: "28px",
                    }}
                  >
                    {bom.data.name}&nbsp;
                    <span title={bom.t("QUANTITY")}>
                      (
                      {bom.data.presetQuantity
                        ? formatNumber(bom.data.presetQuantity * bom.parentItem.quantity)
                        : formatNumber(1 * bom.parentItem.quantity)}
                      )
                    </span>
                  </div>
                </TableCell>
                {/* <td>
						{bom.data.name}
					</td> */}
                {/* <td style={{ width: '10%', textAlign: 'right' }}>{bom.data.price}</td> */}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {bom.data.bom &&
          bom.data.bom.length > 0 &&
          bom.data.bom
            .sort((a, b) =>
              a && b ? a.displaySequence - b.displaySequence : 0,
            )
            .map((child) => (
              <BomItem
                data={child}
                parentItem={bom.parentItem}
                level={bom.level + 1}
                t={bom.t}
              />
            ))}
      </div>
    )
  );
};
// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '0vw',
//     }
// }
// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    solutionList: state.cart.solutions,
    accessoryList: state.cart.accessories,
    unApprovedArraySol: state.cart.unApprovedArraySol,
    unApprovedArrayAcc: state.cart.unApprovedArrayAcc,
    selectedPromoBan: state.cart.selectedPromoBan,
    componentList: state.cart.componentList,
    tenantId: state.auth.tenantId,
    providerType: state.auth.providerType,
    publicBrowsing: state.auth.publicBrowsing,
    tenantData: state.auth.tenantData,
    shoppingCart: state.cart.shoppingCart,
    loggedInUserType: state.auth.userLoginType,
    shoppingQuote: state.quote.shoppingQuote,
    roles: state.auth.roles,
    quoteEnabled: state.auth.quoteEnabled,
    priceSummaryView: state.auth.priceSummaryView,
    permissions: state.auth.userPerms,
    securityGroupsList: state.auth.securityGroupsList,
    providerName: state.auth.providerName,
    loggedInUserName: state.auth.loggedInUserName,
    loggedInUserId: state.auth.loggedInUserId,
    accessToken: state.auth.access_token,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    clearCart: () => dispatch({ type: actionTypes.CLEAR_CART }),
    getUnApprovedItemList: () =>
      dispatch({ type: actionTypes.CHECK_UN_APPROVED_ITEMS }),
    remove: (index, itemType) =>
      dispatch({ type: actionTypes.REMOVE_ITEM, index, itemType }),
    removeComponent: (index, itemType, compType, compIndex) =>
      dispatch({
        type: actionTypes.REMOVE_ITEM,
        index,
        itemType,
        compType,
        compIndex,
      }),
    changeQuantity: (value, index, itemType) =>
      dispatch({ type: actionTypes.CHANGE_QUANTITY, value, index, itemType }),
    changeComponentQuantity: (value, index, itemType, compType, compIndex) =>
      dispatch({
        type: actionTypes.CHANGE_QUANTITY,
        value,
        index,
        itemType,
        compType,
        compIndex,
      }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setPromoBan: (id) => dispatch({ type: actionTypes.CHECK_PROMO_BAN, id }),
    setCart: (cart) => dispatch({ type: actionTypes.SET_CART, cart }),
    setQuote: (data) => dispatch({ type: actionTypes.SET_QUOTE, data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Cart)));
